import * as i0 from '@angular/core';
import { Component, Inject, Input, Pipe, NgModule, ViewChild, PLATFORM_ID, HostListener, Directive, EventEmitter, booleanAttribute, Output, forwardRef } from '@angular/core';
import * as i1$1 from '@angular/common';
import { DOCUMENT, CommonModule, isPlatformBrowser } from '@angular/common';
import * as i1 from '@angular/platform-browser';
import * as i2$1 from '@angular/forms';
import { FormGroup, FormControl, Validators, UntypedFormControl, FormArray, UntypedFormArray, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateTime } from 'luxon';
import { HttpParams } from '@angular/common/http';
import { catchError, Subject, BehaviorSubject, finalize, ReplaySubject, merge, of } from 'rxjs';
import { filter, takeUntil, take, debounceTime, map } from 'rxjs/operators';
import * as i1$2 from 'angular-oauth2-oidc';
import { OAuthErrorEvent } from 'angular-oauth2-oidc';
import * as i2 from '@angular/router';
import { NavigationEnd } from '@angular/router';
import * as i1$3 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i4 from 'primeng/calendar';
import { CalendarModule } from 'primeng/calendar';
import * as i5 from 'primeng/api';
import * as i5$1 from 'primeng/dropdown';
import { DropdownModule } from 'primeng/dropdown';
import * as i5$2 from 'primeng/multiselect';
import { MultiSelectModule } from 'primeng/multiselect';
import * as i4$1 from 'primeng/treeselect';
import { TreeSelect, TreeSelectModule } from 'primeng/treeselect';
import * as i2$2 from 'primeng/autocomplete';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
const _c0 = ["iframe"];
const _c1 = (a0, a1) => ({
  "frame-sm": a0,
  "frame-absolute": a1
});
function IFrameComponent_iframe_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "iframe", 3, 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c1, ctx_r0.small, ctx_r0.absolute))("src", ctx_r0.url, i0.ɵɵsanitizeResourceUrl)("sandbox", ctx_r0.sandbox, i0.ɵɵvalidateIframeAttribute);
  }
}
function IFrameComponent_iframe_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "iframe", 4, 0);
    i0.ɵɵpipe(2, "safe");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c1, ctx_r0.small, ctx_r0.absolute))("srcdoc", i0.ɵɵpipeBind2(2, 3, ctx_r0.html, "html"), i0.ɵɵsanitizeHtml)("sandbox", ctx_r0.sandbox, i0.ɵɵvalidateIframeAttribute);
  }
}
const _c2 = () => ({});
function InputErrorOutputComponent_ng_container_0_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.customErrorMessage, " ");
  }
}
function InputErrorOutputComponent_ng_container_0_ng_container_2_ng_container_1_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    const error_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (tmp_5_0 = error_r2.value) !== null && tmp_5_0 !== undefined ? tmp_5_0 : "!!!missing-error-text!!!", " ");
  }
}
function InputErrorOutputComponent_ng_container_0_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, InputErrorOutputComponent_ng_container_0_ng_container_2_ng_container_1_p_1_Template, 2, 1, "p", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const error_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", error_r2.key !== "required");
  }
}
function InputErrorOutputComponent_ng_container_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, InputErrorOutputComponent_ng_container_0_ng_container_2_ng_container_1_Template, 2, 1, "ng-container", 3);
    i0.ɵɵpipe(2, "keyvalue");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, (tmp_2_0 = ctx_r0.control == null ? null : ctx_r0.control.errors) !== null && tmp_2_0 !== undefined ? tmp_2_0 : i0.ɵɵpureFunction0(3, _c2)));
  }
}
function InputErrorOutputComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, InputErrorOutputComponent_ng_container_0_p_1_Template, 2, 1, "p", 1)(2, InputErrorOutputComponent_ng_container_0_ng_container_2_Template, 3, 4, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.customErrorMessage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.customErrorMessage);
  }
}
function InputPasswordMeterComponent_li_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "li", 4);
  }
  if (rf & 2) {
    const bar_r1 = ctx.$implicit;
    i0.ɵɵstyleProp("background-color", bar_r1);
  }
}
const _c3 = ["inputElement"];
function InputTextboxComponent_div_0_label_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "label", 10);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("for", ctx_r0.id + "_input")("innerHTML", ctx_r0.label + (i0.ɵɵpipeBind1(1, 2, ctx_r0.controlIsRequired$) && ctx_r0.showRequiredStar ? " <em class=\"text-danger\">*</em>" : ""), i0.ɵɵsanitizeHtml);
  }
}
function InputTextboxComponent_div_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 11);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const input_r2 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngTemplateOutlet", input_r2);
  }
}
function InputTextboxComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementContainer(1, 11);
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵlistener("click", function InputTextboxComponent_div_0_div_4_Template_div_click_2_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.suffixClicked.emit($event));
    });
    i0.ɵɵelement(3, "span", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_4_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    const input_r2 = i0.ɵɵreference(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", input_r2);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("input-group-append " + ((tmp_4_0 = ctx_r0.suffixContainerClass) !== null && tmp_4_0 !== undefined ? tmp_4_0 : ""));
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", ctx_r0.suffix, i0.ɵɵsanitizeHtml);
  }
}
function InputTextboxComponent_div_0_i_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 15);
    i0.ɵɵlistener("click", function InputTextboxComponent_div_0_i_5_Template_i_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      ctx_r0.passwordVisible = !ctx_r0.passwordVisible;
      return i0.ɵɵresetView(ctx_r0.type = ctx_r0.passwordVisible ? "text" : "password");
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("fa-eye-slash", ctx_r0.passwordVisible)("fa-eye", !ctx_r0.passwordVisible);
  }
}
function InputTextboxComponent_div_0_input_password_meter_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "input-password-meter", 16);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("barLabel", ctx_r0.passwordMeterLabel)("passControl", ctx_r0.control);
  }
}
function InputTextboxComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 3);
    i0.ɵɵtemplate(2, InputTextboxComponent_div_0_label_2_Template, 2, 4, "label", 4)(3, InputTextboxComponent_div_0_ng_container_3_Template, 1, 1, "ng-container", 5)(4, InputTextboxComponent_div_0_div_4_Template, 4, 4, "div", 6)(5, InputTextboxComponent_div_0_i_5_Template, 1, 4, "i", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, InputTextboxComponent_div_0_input_password_meter_6_Template, 1, 2, "input-password-meter", 8);
    i0.ɵɵelement(7, "input-error-output", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.wrapperClass + " text-start");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.label && ctx_r0.label.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.suffix);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.suffix);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.type === "password" || ctx_r0.passwordVisible) && !!(ctx_r0.control.value == null ? null : ctx_r0.control.value.length));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showPasswordMeter);
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r0.control)("customErrorMessage", ctx_r0.customErrorMessage);
  }
}
function InputTextboxComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "input", 17, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.inputClass + " position-relative");
    i0.ɵɵclassProp("password-peek-padding", ctx_r0.passwordVisible || ctx_r0.type === "password");
    i0.ɵɵproperty("autocomplete", ctx_r0.autocomplete)("formControl", ctx_r0.control)("id", ctx_r0.id + "_input")("placeholder", ctx_r0.placeholder)("readOnly", ctx_r0.readonly)("type", ctx_r0.type);
    i0.ɵɵattribute("autofocus", ctx_r0.autofocusInput ? true : null)("autocapitalize", ctx_r0.autocapitalize ? ctx_r0.autocapitalize : null);
  }
}
function InputCheckboxComponent_em_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 4);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
const _c4 = ["calendar"];
const _c5 = () => ({
  width: "100%"
});
const _c6 = () => ({
  width: "calc(100% - 33px)"
});
function InputDatepickerComponent_em_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 7);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function InputDatepickerComponent_p_footer_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-footer")(1, "div", 8)(2, "div", 9)(3, "button", 10);
    i0.ɵɵlistener("click", function InputDatepickerComponent_p_footer_8_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r2);
      i0.ɵɵnextContext();
      const calendar_r3 = i0.ɵɵreference(7);
      return i0.ɵɵresetView(calendar_r3.hideOverlay());
    });
    i0.ɵɵtext(4, " Best\xE4tigen ");
    i0.ɵɵelementEnd()()()();
  }
}
const _c7 = ["dropdown"];
function InputDropdownComponent_label_1_em_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 6);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function InputDropdownComponent_label_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 4);
    i0.ɵɵlistener("click", function InputDropdownComponent_label_1_Template_label_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.control.enabled && ctx_r2.openDropdown($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, InputDropdownComponent_label_1_em_2_Template, 2, 0, "em", 5);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("for", ctx_r2.id + "_input");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 3, ctx_r2.controlIsRequired$) && ctx_r2.showRequiredStar);
  }
}
function InputFileComponent_small_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 6);
    i0.ɵɵtext(1, "Keine Datei gew\xE4hlt");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("text-danger", ctx_r2.control.invalid && ctx_r2.control.touched);
  }
}
function InputFileComponent_small_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.fileName);
  }
}
function InputMultiselectComponent_label_1_em_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 6);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function InputMultiselectComponent_label_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 4);
    i0.ɵɵlistener("click", function InputMultiselectComponent_label_1_Template_label_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.control.enabled && ctx_r2.openDropdown($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, InputMultiselectComponent_label_1_em_2_Template, 2, 0, "em", 5);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("for", ctx_r2.id + "_input");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 3, ctx_r2.controlIsRequired$) && ctx_r2.showRequiredStar);
  }
}
function InputTextareaComponent_label_1_em_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 5);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function InputTextareaComponent_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 3);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, InputTextareaComponent_label_1_em_2_Template, 2, 0, "em", 4);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("for", ctx_r0.id + "_input");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 3, ctx_r0.controlIsRequired$) && ctx_r0.showRequiredStar);
  }
}
function InputTreeselectComponent_label_1_em_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 5);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function InputTreeselectComponent_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 3);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, InputTreeselectComponent_label_1_em_2_Template, 2, 0, "em", 4);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("for", ctx_r0.id + "_input");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 3, ctx_r0.controlIsRequired$) && ctx_r0.showRequiredStar);
  }
}
const _c8 = () => [];
function InputAutocompleteComponent_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "label", 5);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("for", ctx_r0.id + "_input")("innerHTML", ctx_r0.label + (i0.ɵɵpipeBind1(1, 2, ctx_r0.controlIsRequired$) && ctx_r0.showRequiredStar ? " <em class=\"text-danger\">*</em>" : ""), i0.ɵɵsanitizeHtml);
  }
}
function InputAutocompleteComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 6);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const input_r2 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", input_r2);
  }
}
function InputAutocompleteComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementContainer(1, 6);
    i0.ɵɵelementStart(2, "div", 8);
    i0.ɵɵelement(3, "span", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const input_r2 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", input_r2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHtml", ctx_r0.suffix, i0.ɵɵsanitizeHtml);
  }
}
function InputAutocompleteComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-autoComplete", 10, 1);
    i0.ɵɵlistener("completeMethod", function InputAutocompleteComponent_ng_template_4_Template_p_autoComplete_completeMethod_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.completeMethod.emit($event));
    })("onFocus", function InputAutocompleteComponent_ng_template_4_Template_p_autoComplete_onFocus_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const autoComplete_r4 = i0.ɵɵreference(1);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.showOnFocus && autoComplete_r4.show());
    })("onSelect", function InputAutocompleteComponent_ng_template_4_Template_p_autoComplete_onSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const autoComplete_r4 = i0.ɵɵreference(1);
      const ctx_r0 = i0.ɵɵnextContext();
      ctx_r0.onSelect.emit($event);
      return i0.ɵɵresetView(autoComplete_r4.hide(true));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    let tmp_6_0;
    let tmp_9_0;
    let tmp_11_0;
    let tmp_12_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("appendTo", ctx_r0.appendTo)("completeOnFocus", ctx_r0.completeOnFocus)("dataKey", (tmp_5_0 = ctx_r0.dataKey) !== null && tmp_5_0 !== undefined ? tmp_5_0 : "")("field", (tmp_6_0 = ctx_r0.field) !== null && tmp_6_0 !== undefined ? tmp_6_0 : "")("forceSelection", ctx_r0.forceSelection)("formControl", ctx_r0.control)("placeholder", (tmp_9_0 = ctx_r0.placeholder) !== null && tmp_9_0 !== undefined ? tmp_9_0 : "")("showEmptyMessage", ctx_r0.showEmptyMessage)("suggestions", (tmp_11_0 = ctx_r0.suggestions) !== null && tmp_11_0 !== undefined ? tmp_11_0 : i0.ɵɵpureFunction0(10, _c8))("type", (tmp_12_0 = ctx_r0.type) !== null && tmp_12_0 !== undefined ? tmp_12_0 : "");
  }
}
let LightSwitchComponent = /*#__PURE__*/(() => {
  class LightSwitchComponent {
    constructor(document) {
      this.document = document;
      this.disableClick = false;
      this.onIcon = 'fa fa-fw fa-sun-o';
      this.offIcon = 'fa fa-fw fa-moon-o';
      const savedState = localStorage.getItem('darkmode');
      if (savedState) {
        if (savedState === '1') {
          this.activateDarkMode();
        } else {
          this.activateLightMode();
        }
        return;
      }
      const darkMediaQuery = matchMedia('(prefers-color-scheme: dark)');
      const lightMediaQuery = matchMedia('(prefers-color-scheme: light)');
      const isDarkMode = darkMediaQuery.matches;
      const isLightMode = lightMediaQuery.matches;
      const isNotSpecified = matchMedia('(prefers-color-scheme: no-preference)').matches;
      const hasNoSupport = !isDarkMode && !isLightMode && !isNotSpecified;
      if (isDarkMode) {
        this.activateDarkMode();
      } else if (isLightMode) {
        this.activateLightMode();
      } else if (isNotSpecified || hasNoSupport) {
        const now = new Date();
        const hour = now.getHours();
        if (hour < 6 || hour >= 19) {
          this.activateDarkMode();
        }
      }
      try {
        darkMediaQuery.addEventListener('change', e => e.matches && this.activateDarkMode());
        lightMediaQuery.addEventListener('change', e => e.matches && this.activateLightMode());
      } catch (error) {
        try {
          darkMediaQuery.addListener(e => e.matches && this.activateDarkMode());
          lightMediaQuery.addListener(e => e.matches && this.activateLightMode());
        } catch (error2) {
          console.log(error2);
        }
      }
    }
    setMode() {
      if (this.off) {
        localStorage.setItem('darkmode', '1');
        this.activateDarkMode();
      } else {
        localStorage.setItem('darkmode', '0');
        this.activateLightMode();
      }
    }
    activateDarkMode() {
      this.off = false;
      this.document.getElementsByTagName('body')[0].classList.add('darkmode');
    }
    activateLightMode() {
      this.off = true;
      this.document.getElementsByTagName('body')[0].classList.remove('darkmode');
    }
    static {
      this.ɵfac = function LightSwitchComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LightSwitchComponent)(i0.ɵɵdirectiveInject(DOCUMENT));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LightSwitchComponent,
        selectors: [["light-switch"]],
        inputs: {
          disableClick: "disableClick",
          onIcon: "onIcon",
          offIcon: "offIcon"
        },
        decls: 1,
        vars: 6,
        consts: [[3, "click"]],
        template: function LightSwitchComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "i", 0);
            i0.ɵɵlistener("click", function LightSwitchComponent_Template_i_click_0_listener() {
              return !ctx.disableClick && ctx.setMode();
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap("text-white " + (ctx.off ? ctx.offIcon : ctx.onIcon));
            i0.ɵɵclassProp("fa-sun-o", !ctx.off)("fa-moon-o", ctx.off);
          }
        },
        styles: ["i[_ngcontent-%COMP%]{cursor:pointer;font-size:1.4rem;opacity:.5;transition:all ease-in-out .2s}i[_ngcontent-%COMP%]:hover{opacity:.9}"]
      });
    }
  }
  return LightSwitchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SafePipe = /*#__PURE__*/(() => {
  class SafePipe {
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
    }
    transform(value, type) {
      switch (type) {
        case 'html':
          return this.sanitizer.bypassSecurityTrustHtml(value);
        case 'style':
          return this.sanitizer.bypassSecurityTrustStyle(value);
        case 'script':
          return this.sanitizer.bypassSecurityTrustScript(value);
        case 'url':
          return this.sanitizer.bypassSecurityTrustUrl(value);
        case 'resourceUrl':
          return this.sanitizer.bypassSecurityTrustResourceUrl(value);
        default:
          throw new Error(`Invalid safe type specified: ${type}`);
      }
    }
    static {
      this.ɵfac = function SafePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SafePipe)(i0.ɵɵdirectiveInject(i1.DomSanitizer, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "safe",
        type: SafePipe,
        pure: true
      });
    }
  }
  return SafePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SafePipeModule = /*#__PURE__*/(() => {
  class SafePipeModule {
    static {
      this.ɵfac = function SafePipeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SafePipeModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SafePipeModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [SafePipe]
      });
    }
  }
  return SafePipeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LightSwitchModule = /*#__PURE__*/(() => {
  class LightSwitchModule {
    static {
      this.ɵfac = function LightSwitchModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LightSwitchModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: LightSwitchModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, SafePipeModule]
      });
    }
  }
  return LightSwitchModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// TODO remove or fix sandbox-binding
let IFrameComponent = /*#__PURE__*/(() => {
  class IFrameComponent {
    constructor() {
      this.sandbox = 'allow-presentation allow-same-origin allow-scripts';
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ngOnChanges(changes) {
      this.ngAfterViewInit();
    }
    ngAfterViewInit() {
      if (!this.iframe) {
        return;
      }
      const frame = this.iframe.nativeElement;
      frame.height = this.frameHeight ?? '';
      if (this.sandbox) {
        frame.sandbox = this.sandbox;
      }
    }
    static {
      this.ɵfac = function IFrameComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IFrameComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IFrameComponent,
        selectors: [["i-frame"]],
        viewQuery: function IFrameComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.iframe = _t.first);
          }
        },
        inputs: {
          url: "url",
          html: "html",
          frameHeight: "frameHeight",
          small: "small",
          absolute: "absolute",
          sandbox: "sandbox"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 2,
        vars: 2,
        consts: [["iframe", ""], [3, "ngClass", "src", "sandbox", 4, "ngIf"], [3, "ngClass", "srcdoc", "sandbox", 4, "ngIf"], [3, "ngClass", "src", "sandbox"], [3, "ngClass", "srcdoc", "sandbox"]],
        template: function IFrameComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IFrameComponent_iframe_0_Template, 2, 6, "iframe", 1)(1, IFrameComponent_iframe_1_Template, 3, 9, "iframe", 2);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.url);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.html);
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgIf, SafePipe],
        styles: ["iframe[_ngcontent-%COMP%]{border:.1rem solid darkgrey;border-radius:5px;width:100%;height:590px}"]
      });
    }
  }
  return IFrameComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IFrameModule = /*#__PURE__*/(() => {
  class IFrameModule {
    static {
      this.ɵfac = function IFrameModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IFrameModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IFrameModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, SafePipeModule]
      });
    }
  }
  return IFrameModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint angular/document-service: 0 */
const isMobile = {
  Android: () => !!navigator.userAgent.match(/Android/i),
  BlackBerry: () => !!navigator.userAgent.match(/BlackBerry/i),
  iOS: () => !!navigator.userAgent.match(/iPhone|iPad|iPod/i),
  Opera: () => !!navigator.userAgent.match(/Opera Mini/i),
  Windows: () => !!navigator.userAgent.match(/IEMobile/i) || !!navigator.userAgent.match(/WPDesktop/i),
  // eslint-disable-next-line id-blacklist
  any: () => isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows()
};
function isSafari() {
  return !!navigator.vendor && navigator.vendor.includes('Apple') && !!navigator.userAgent && navigator.userAgent.includes('CriOS') && navigator.userAgent.includes('FxiOS');
}
function isRobot() {
  const userAgent = navigator.userAgent;
  return /bot|crawler|spider|crawling/i.test(userAgent);
}
function isNullOrEmpty(value) {
  const val = value;
  return !val || typeof val === 'string' && val.trim() === ''; // || (typeof value === 'number' && value );
}
/*
export function logInvalidFormFields(parent: FormGroup | FormArray, detailed: boolean = false, combinedKey: string = ''): void {
  for (const key of Object.keys(parent.controls)) {
    const control = parent.controls[key];
    if (control instanceof FormArray) {
      if (control.invalid) {
        console.log(`FormArray [${combinedKey}${key}] is invalid`, detailed ? control.value : null, detailed ? control.errors : null);
      }
      logInvalidFormFields(control, detailed, `${combinedKey}${key}.`);
    } else if (control instanceof FormGroup) {
      if (control.invalid) {
        console.log(`FormGroup [${combinedKey}${key}] is invalid`, detailed ? control.value : null, detailed ? control.errors : null);
      }
      logInvalidFormFields(control, detailed, `${combinedKey}${key}.`);
    } else if (control.invalid) {
      console.log(`Control [${combinedKey}${key}] is invalid`, detailed ? control.value : null, detailed ? control.errors : null);
    }
  }
}
*/
/**
 * @param {Document} doc - pass injected Document when executing in SSR
 * @returns {number}
 */
function getMaxBrowserWidth(doc = document) {
  return Math.max(doc.body.scrollWidth, doc.documentElement.scrollWidth, doc.body.offsetWidth, doc.documentElement.offsetWidth, doc.documentElement.clientWidth);
}
/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item);
}
/**
 * Deep merge two objects.
 * @param target
 * @param sources
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function mergeDeep(target, ...sources) {
  if (!sources.length) {
    return target;
  }
  const source = sources.shift();
  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, {
            [key]: {}
          });
        }
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, {
          [key]: source[key]
        });
      }
    }
  }
  return mergeDeep(target, ...sources);
}
function pagedRequestToQueryParams(pagedRequest) {
  let params = new HttpParams();
  Object.keys(pagedRequest).forEach(key => {
    const keyValue = pagedRequest[key];
    if (keyValue instanceof Array) {
      keyValue.forEach(val => {
        params = params.append(key, val);
      });
    } else if (keyValue !== undefined && keyValue !== null && keyValue !== '') {
      params = params.append(key, '' + keyValue);
    }
  });
  return params;
}
function round(nmbr, decimalCount) {
  return Math.round(nmbr * 10 ** decimalCount) / 10 ** decimalCount;
}
function dateInPast(date) {
  return (typeof date === 'string' ? DateTime.fromISO(date) : date) < DateTime.now();
}
function dateInFuture(date) {
  return (typeof date === 'string' ? DateTime.fromISO(date) : date) > DateTime.now();
}
function dateBetween(dateStart, dateEnd) {
  return dateInPast(dateStart) && dateInFuture(dateEnd);
}
/**
 * use this, if you want to have a fallback for an observable
 * When the first observable fails, the next one gets executed, when the next one fails we will continue with the next one etc.
 * When we have a successful output we will emit the result and stop executing the remaining fallbacks
 * You will get the result of the first successful request.
 * @param {Observable<any>[]} observables
 * @returns {Observable<any>}
 */
function observableWithFallbacks(observables) {
  if (observables.length === 0) {
    throw Error('No remaining fallback-languages to try.');
  }
  // Recursive case: execute the first request and move on to the next one if it fails
  const [firstRequest, ...remainingRequests] = observables;
  return firstRequest
  // If the request fails, move on to the next request
  .pipe(catchError(() => observableWithFallbacks(remainingRequests)));
}

// noinspection AngularMissingOrInvalidDeclarationInModule
let BaseComponent = /*#__PURE__*/(() => {
  class BaseComponent {
    constructor() {
      this.ngUnsubscribe = new Subject();
    }
    ngOnDestroy() {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    reinitializeNgUnsubscribe() {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
      this.ngUnsubscribe = new Subject();
    }
    static {
      this.ɵfac = function BaseComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BaseComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BaseComponent,
        selectors: [["ng-component"]],
        decls: 0,
        vars: 0,
        template: function BaseComponent_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return BaseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BaseLoginComponent = /*#__PURE__*/(() => {
  class BaseLoginComponent extends BaseComponent {
    constructor(oauthService, router, route, changeDetector, platformId, document) {
      super();
      this.oauthService = oauthService;
      this.router = router;
      this.route = route;
      this.changeDetector = changeDetector;
      this.platformId = platformId;
      this.document = document;
      /**
       * used as loading indicator in the template when something is being executed
       * @type {Subject<boolean>}
       */
      this.loading$ = new Subject();
      /**
       * contains the second-factor methods of an user after trying to login
       * @type {BehaviorSubject<SecondFactorMethod[]>}
       */
      this.usersTwoFactorProviders$ = new BehaviorSubject([]);
      /**
       * contains the date-time when another second-factor mail can be sent (e.g. displaying a countdown in the ui)
       * @type {BehaviorSubject<DateTime | null>}
       */
      this.resendingMailSecondFactorDisabledUntil$ = new BehaviorSubject(null);
      /**
       * Amount of seconds to wait, before allowing to send a second second-factor-mail
       * @type {number}
       * @protected
       */
      this.enableResendingSecondFactorMailAfter = 30;
      /**
       * when provided, on sign-in-success we will try to redirect the user to the url provided in the query-param-name provided here
       * @type {string} - default = 'req'
       * @protected
       */
      this.redirectParamKeyOnSuccess = 'req';
    }
    /**
     * setup form, inits the oauth-settings and tries to login via sso, when possible
     */
    ngOnInit() {
      this.loginFormGroup = new FormGroup({
        userName: new FormControl('', {
          validators: Validators.required,
          nonNullable: true
        }),
        password: new FormControl('', {
          validators: Validators.required,
          nonNullable: true
        }),
        cookiesAccepted: new FormControl(isPlatformBrowser(this.platformId) ? !!localStorage.getItem('loginCookiesAccepted') : false, {
          validators: Validators.requiredTrue,
          nonNullable: true
        }),
        secondFactorMethod: new FormControl(null),
        secondFactorCode: new FormControl(null),
        secondFactorRememberDevice: new FormControl(false, {
          nonNullable: true
        }),
        stayLoggedIn: new FormControl(false, {
          nonNullable: true
        })
      });
      this.usersTwoFactorProviders$.next([]);
      this.loginFormGroup.controls.secondFactorCode.valueChanges.pipe(filter(v => v !== null && !!v.length && this.loginFormGroup.value.secondFactorMethod !== SecondFactorMethod.RecoveryCode)) // recover-codes are not numerical only -> allow everything
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe(v => this.loginFormGroup.controls.secondFactorCode.setValue(v.replace(/\D/g, '').substr(0, 6), {
        emitEvent: false
      }));
      // get single-sign-on-data from localstorage + init oauth
      if (isPlatformBrowser(this.platformId)) {
        const providerDataString = localStorage.getItem('sso-provider');
        let providerData;
        if (providerDataString) {
          providerData = JSON.parse(providerDataString);
          localStorage.removeItem('sso-provider');
          this.oauthConfigure(providerData);
          this.oauthService.loadDiscoveryDocumentAndTryLogin();
        }
        this.oauthService.events.pipe(takeUntil(this.ngUnsubscribe)).subscribe(event => {
          if (event.type === 'token_received' && providerData) {
            this.signInSingleSignOn(this.oauthService.getIdToken(), providerData.key).subscribe(result => this.handleSignInResult(result, {
              providerKey: providerData.key,
              token: this.oauthService.getIdToken()
            }));
          } else if (event instanceof OAuthErrorEvent) {
            console.error(event.params);
            this.handleSingleSignOnFailed();
            this.router.navigate([], {
              replaceUrl: true,
              queryParams: {
                code: null
              },
              queryParamsHandling: 'merge'
            });
          }
        });
      }
    }
    /**
     * Key-combination enables setting of hidden auth-providers
     *  - interacts with allowDisplayOfHiddenProviders$
     * @private
     */
    allowDisplayingHiddenProviders() {
      this.allowDisplayOfHiddenProviders = true;
    }
    /**
     * Key-combination disables setting of hidden auth-providers
     * - interacts with allowDisplayOfHiddenProviders$
     * @private
     */
    preventDisplayingHiddenProviders() {
      this.allowDisplayOfHiddenProviders = false;
    }
    /**
     * Execute it when allowDisplayHiddenProviders === true (triggered by keycombination) & clicked on e.g Login-Header
     * The method is used to show hidden availableSingleSignOnProviders, when available
     * @private
     */
    showHiddenAuthProviders() {
      if (this.allowDisplayOfHiddenProviders) {
        this.availableSingleSignOnProviders$.next(this.availableSingleSignOnProviders$.value.map(p => ({
          ...p,
          uiIsHidden: false
        })));
      }
    }
    /**
     * login-method to use in template (button)
     */
    login() {
      this.loginFormGroup.markAllAsTouched();
      if (isPlatformBrowser(this.platformId)) {
        if (this.loginFormGroup.invalid) {
          this.changeDetector.detectChanges();
          const mailVal = this.document.getElementById(this.userNameInputId)?.value;
          const passVal = this.document.getElementById(this.passwordInputId)?.value;
          // JS password-paste-plugin error-workaround - TODO notify when inputs not found?
          if (!this.loginFormGroup.value.secondFactorMethod && mailVal && passVal && (mailVal !== this.loginFormGroup.value.userName || passVal !== this.loginFormGroup.value.password)) {
            this.loginFormGroup.controls.userName.setValue(mailVal);
            this.loginFormGroup.controls.password.setValue(passVal);
            this.login();
            return;
          }
          this.displayCheckInputNotification();
          return;
        }
        localStorage.setItem('loginCookiesAccepted', 'true');
      }
      const formVal = this.loginFormGroup.getRawValue();
      this.loginFormGroup.disable();
      this.loading$.next(true);
      // login via two-factor or recovery-code
      if (formVal.secondFactorMethod) {
        this.signInViaSecondFactor(formVal.userName, formVal.password, formVal.secondFactorMethod, formVal.secondFactorCode, formVal.stayLoggedIn, formVal.secondFactorRememberDevice).pipe(finalize(() => {
          this.loginFormGroup.enable();
          this.loading$.next(false);
        })).subscribe(result => this.handleSignInResult(result));
      }
      // login via username + pass
      else {
        this.signIn(formVal.userName, formVal.password, formVal.stayLoggedIn).pipe(finalize(() => {
          this.loginFormGroup.enable();
          this.loading$.next(false);
        })).subscribe(data => this.handleSignInResult(data.result, undefined, data.secondFactors));
      }
    }
    /**
     * oauth-login-method to use in template (sso-provider-button)
     */
    loginSingleSignOn(provider) {
      localStorage.setItem('sso-provider', JSON.stringify(provider));
      localStorage.setItem('sso-redirect', this.router.url);
      this.oauthConfigure(provider);
      this.oauthService.loadDiscoveryDocumentAndTryLogin().then(() => this.oauthService.initCodeFlow());
    }
    /**
     * Initiates sending of second factor via mail - handle success and errors in your class
     */
    requestMail2FA(ignoreTimeout) {
      if (!ignoreTimeout) {
        const waitUntil = this.resendingMailSecondFactorDisabledUntil$.value;
        if (waitUntil && dateInFuture(waitUntil)) {
          this.displaySecondFactorMailTimeout();
          return;
        }
      }
      this.resendingMailSecondFactorDisabledUntil$.next(DateTime.now().plus({
        seconds: this.enableResendingSecondFactorMailAfter
      }));
      this.sendSecondFactorMail().subscribe();
    }
    oauthConfigure(provider) {
      this.oauthService.configure({
        // Url of the Identity Provider
        issuer: provider.authority,
        strictDiscoveryDocumentValidation: false,
        // true throws errors
        // URL of the SPA to redirect the user to after login
        // eslint-disable-next-line angular/window-service
        redirectUri: window.location.origin,
        //  + this.localizeRoute.transform('/account/external-login'),
        // The SPA's id. The SPA is registerd with this id at the auth-server
        clientId: provider.audience,
        // Just needed if your auth server demands a secret. In general, this
        // is a sign that the auth server is not configured with SPAs in mind
        // and it might not enforce further best practices vital for security
        // such applications.
        // dummyClientSecret: 'secret',
        responseType: 'code',
        // set the scope for the permissions the client should request
        // Important: Request offline_access to get a refresh token
        // The api scope is a usecase specific one
        scope: provider.scopes.join(' '),
        showDebugInformation: false
      });
    }
    /**
     * Default handling of sign-in-results
     * @param {SignInResult} result
     * @param singleSignOnData
     * @param {SecondFactorMethod[]} availableSecondFactors
     * @private
     */
    handleSignInResult(result, singleSignOnData, availableSecondFactors) {
      switch (result) {
        case SignInResult.Success:
          const redirectRoute = localStorage.getItem('sso-redirect');
          if (redirectRoute) {
            localStorage.removeItem('sso-redirect');
            this.router.navigateByUrl(redirectRoute);
            break;
          }
          // route to protected route when preserved in "req" query-param
          this.route.queryParams.pipe(take(1)).pipe(filter(params => !!this.redirectParamKeyOnSuccess && !!params[this.redirectParamKeyOnSuccess])).subscribe(params => this.router.navigateByUrl(params[this.redirectParamKeyOnSuccess]));
          this.handleSignedIn();
          this.loginFormGroup.reset();
          break;
        case SignInResult.ActivationPending:
          this.handleActivationPending();
          break;
        case SignInResult.SecondFactorRequired:
          this.usersTwoFactorProviders$.next(availableSecondFactors);
          this.loginFormGroup.controls.secondFactorMethod.setValue(availableSecondFactors.includes(SecondFactorMethod.Authenticator) ? SecondFactorMethod.Authenticator : availableSecondFactors[0]);
          if (this.loginFormGroup.value.secondFactorMethod === SecondFactorMethod.Email) {
            this.requestMail2FA(true);
          }
          break;
        case SignInResult.Disabled:
          this.handleDisabledAccount();
          break;
        case SignInResult.Failed:
          this.handleSignInFailed();
          break;
        case SignInResult.LockedOut:
          this.handleLockedAccount();
          break;
        case SignInResult.RegistrationRequired:
          this.handleRegistrationRequired(singleSignOnData.providerKey, singleSignOnData.token);
          break;
        default:
          this.displayUnknownSignInError();
      }
    }
    static {
      this.ɵfac = function BaseLoginComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BaseLoginComponent)(i0.ɵɵdirectiveInject(i1$2.OAuthService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(DOCUMENT));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BaseLoginComponent,
        selectors: [["ng-component"]],
        hostBindings: function BaseLoginComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.alt.shift", function BaseLoginComponent_keydown_alt_shift_HostBindingHandler() {
              return ctx.allowDisplayingHiddenProviders();
            }, false, i0.ɵɵresolveWindow)("keydown.shift.alt", function BaseLoginComponent_keydown_shift_alt_HostBindingHandler() {
              return ctx.allowDisplayingHiddenProviders();
            }, false, i0.ɵɵresolveWindow)("keyup.alt.shift", function BaseLoginComponent_keyup_alt_shift_HostBindingHandler() {
              return ctx.preventDisplayingHiddenProviders();
            }, false, i0.ɵɵresolveWindow)("keyup.shift.alt", function BaseLoginComponent_keyup_shift_alt_HostBindingHandler() {
              return ctx.preventDisplayingHiddenProviders();
            }, false, i0.ɵɵresolveWindow);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 0,
        vars: 0,
        template: function BaseLoginComponent_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return BaseLoginComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
// eslint-disable-next-line no-shadow
var SecondFactorMethod = /*#__PURE__*/function (SecondFactorMethod) {
  SecondFactorMethod["Email"] = "email";
  SecondFactorMethod["Authenticator"] = "authenticator";
  SecondFactorMethod["RecoveryCode"] = "recovery-code";
  return SecondFactorMethod;
}(SecondFactorMethod || {});
// eslint-disable-next-line no-shadow
var SignInResult = /*#__PURE__*/function (SignInResult) {
  SignInResult["Success"] = "success";
  SignInResult["SecondFactorRequired"] = "second_factor_required";
  SignInResult["Failed"] = "failed";
  SignInResult["RegistrationRequired"] = "registration_required";
  SignInResult["LockedOut"] = "locked_out";
  SignInResult["Disabled"] = "disabled";
  SignInResult["ActivationPending"] = "activation_pending";
  return SignInResult;
}(SignInResult || {});
// noinspection AngularMissingOrInvalidDeclarationInModule
let BaseDirective = /*#__PURE__*/(() => {
  class BaseDirective {
    constructor() {
      this.ngUnsubscribe = new Subject();
    }
    ngOnDestroy() {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    static {
      this.ɵfac = function BaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BaseDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BaseDirective,
        selectors: [["", "baseDirective", ""]]
      });
    }
  }
  return BaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function getFormGroup(data) {
  const form = {};
  for (const [key, value] of Object.entries(data)) {
    if (value === null || value === undefined || typeof value.getMonth === 'function') {
      form[key] = new UntypedFormControl(value);
    } else {
      switch (typeof value) {
        case 'string':
          form[key] = new FormControl(value);
          break;
        case 'number':
          form[key] = new FormControl(value);
          break;
        case 'boolean':
          form[key] = new FormControl(value);
          break;
        case 'object':
          form[key] = getFormGroup(value);
          break;
      }
    }
  }
  return data instanceof Array ? new FormArray(Object.values(form)) : new FormGroup(form);
}
function logInvalidFormFields(parent, detailed = false, combinedKey = '') {
  for (const key of Object.keys(parent.controls)) {
    const control = parent.controls[key];
    if (control instanceof UntypedFormArray) {
      if (control.invalid) {
        console.log(`FormArray [${combinedKey}${key}] is invalid`, detailed ? control.value : null, detailed ? control.errors : null);
      }
      logInvalidFormFields(control, detailed, `${combinedKey}${key}.`);
    } else if (control instanceof UntypedFormGroup) {
      if (control.invalid) {
        console.log(`FormGroup [${combinedKey}${key}] is invalid`, detailed ? control.value : null, detailed ? control.errors : null);
      }
      logInvalidFormFields(control, detailed, `${combinedKey}${key}.`);
    } else if (control.invalid) {
      console.log(`Control [${combinedKey}${key}] is invalid`, detailed ? control.value : null, detailed ? control.errors : null);
    }
  }
}
function logDirtyControls(parent, detailed = false, combinedKey = '') {
  for (const key of Object.keys(parent.controls)) {
    const control = parent.controls[key];
    if (control instanceof UntypedFormArray) {
      if (control.dirty) {
        console.log(`FormArray [${combinedKey}${key}] is dirty`, detailed ? control.value : null, detailed ? control.errors : null);
      }
      logDirtyControls(control, detailed, `${combinedKey}${key}.`);
    } else if (control instanceof UntypedFormGroup) {
      if (control.dirty) {
        console.log(`FormGroup [${combinedKey}${key}] is dirty`, detailed ? control.value : null, detailed ? control.errors : null);
      }
      logDirtyControls(control, detailed, `${combinedKey}${key}.`);
    } else if (control.dirty) {
      console.log(`Control [${combinedKey}${key}] is dirty`, detailed ? control.value : null, detailed ? control.errors : null);
    }
  }
}
// TODO remove? there is a markAllAsTouched on formgroups
function markAsTouchedWithChildren(control) {
  if (control instanceof UntypedFormControl) {
    control.markAsTouched({
      onlySelf: true
    });
    control.statusChanges.emit('TOUCHED');
  } else if (control instanceof UntypedFormArray) {
    const formArray = control;
    formArray.markAsTouched({
      onlySelf: true
    });
    control.statusChanges.emit('TOUCHED');
    for (let i = 0; i < formArray.length; i++) {
      markAsTouchedWithChildren(formArray.at(i));
    }
  } else if (control instanceof UntypedFormGroup) {
    const formGroup = control;
    formGroup.markAsTouched({
      onlySelf: true
    });
    Object.keys(formGroup.controls).forEach(key => {
      const subControl = formGroup.get(key);
      markAsTouchedWithChildren(subControl);
    });
  }
}
function removeFormControlError(control, errorkey) {
  const err = control.errors; // get control errors
  if (err) {
    delete err[errorkey]; // delete your own error
    if (!Object.keys(err).length) {
      // if no errors left
      control.setErrors(null); // set control errors to null making it VALID
    } else {
      control.setErrors(err); // controls got other errors so set them back
    }
  }
}
let InputEmailDirective = /*#__PURE__*/(() => {
  class InputEmailDirective extends BaseDirective {
    constructor() {
      super(...arguments);
      this.emailErrorDisplayText = 'Invalid email';
      this.control = new FormControl(null);
    }
    set _control(value) {
      this.control = value;
    }
    ngOnChanges(changes) {
      if (changes['control']) {
        this.ngOnInit();
      }
    }
    ngOnInit() {
      this.valueChanges$?.unsubscribe();
      this.valueChanges$ = this.control.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe(v => {
        v = (v ?? '').toLowerCase();
        // eslint-disable-next-line max-len,no-control-regex
        const match = v.match(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/g);
        if (v.length && (!match || match.length === 0 || match.length > 2 || match[0] !== v)) {
          this.control.setErrors({
            email: this.emailErrorDisplayText,
            ...this.control.errors
          });
        } else {
          removeFormControlError(this.control, 'email');
        }
      });
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵInputEmailDirective_BaseFactory;
        return function InputEmailDirective_Factory(__ngFactoryType__) {
          return (ɵInputEmailDirective_BaseFactory || (ɵInputEmailDirective_BaseFactory = i0.ɵɵgetInheritedFactory(InputEmailDirective)))(__ngFactoryType__ || InputEmailDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: InputEmailDirective,
        selectors: [["", "inputEmail", ""]],
        inputs: {
          emailErrorDisplayText: "emailErrorDisplayText",
          _control: [0, "control", "_control"]
        },
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return InputEmailDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputEmailModule = /*#__PURE__*/(() => {
  class InputEmailModule {
    static {
      this.ɵfac = function InputEmailModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputEmailModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InputEmailModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return InputEmailModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// noinspection AngularMissingOrInvalidDeclarationInModule
let InputBaseComponent = /*#__PURE__*/(() => {
  class InputBaseComponent extends BaseComponent {
    constructor() {
      super(...arguments);
      // fires when control-value changes
      this.change = new EventEmitter();
      // fires when control gets replaced (ngOnChange)
      this.controlReplaced = new EventEmitter();
      this.logMissingLabel = true; // do not log when label is missing
      this.readonly = false; // true -> forbid writing
      this.inputClass = 'form-control'; // f.e. 'form-control'              TODO set in module
      this.wrapperClass = 'form-group'; // f.e. 'form-group'                TODO set in module
      this.showRequiredStar = true; // false -> do not show star in template
      this.setRequiredOnInit = false; // sets req.Validator in OnInit
      this.unsetRequiredOnDestroy = false; // unsets req.Validator in OnDestroy
      this.enableOnInit = false; // enables the control in OnInit
      this.disableOnInit = false; // disables the control in OnInit
      this.enableOnDestroy = false; // enables the control in OnDestroy
      this.disableOnDestroy = false; // disables the control in OnDestroy
      this.clearOnDestroy = false; // clears the control in OnDestroy
      this.control = new FormControl(null); // formcontrol
      this.controlIsRequired$ = new ReplaySubject(); // indicates if the control has the required-validator
    }
    set _control(value) {
      const replaced = !!this.control;
      this.control = value;
      if (replaced) {
        // TODO - hmm will be always triggered - refactor
        this.controlReplaced.emit();
        this.ngOnInit();
      }
    }
    ngOnInit() {
      if (!this.id) {
        console.warn('keine Id für input mit label"' + this.label + '" und value "' + this.control?.value + '" gesetzt');
      }
      if (this.disableOnInit) {
        this.control.disable();
      } else if (this.enableOnInit) {
        this.control.enable();
      }
      if (this.initWithValue !== undefined && (this.control.value === null || this.control.value === '')) {
        setTimeout(() => this.control.setValue(this.initWithValue, {
          emitEvent: false
        }));
      }
      if (this.setRequiredOnInit) {
        // workaround expression-changed
        setTimeout(() => {
          this.setRequiredState(true);
          this.controlIsRequired$.next(this.control.hasValidator(Validators.required));
        });
      } else {
        this.controlIsRequired$.next(this.control.hasValidator(Validators.required));
      }
      if (this.valueChanges$) {
        this.valueChanges$.unsubscribe();
      }
      let prevValue = this.control.value;
      this.valueChanges$ = this.control.valueChanges.pipe(debounceTime(50)).pipe(filter(val => val !== prevValue)).pipe(takeUntil(this.ngUnsubscribe)).subscribe(val => {
        prevValue = val;
        this.control.markAsDirty();
        this.change.emit(val);
      });
    }
    setRequiredState(required) {
      if (required && !this.control.hasValidator(Validators.required)) {
        this.control.addValidators(Validators.required);
      } else if (!required && this.control.hasValidator(Validators.required)) {
        this.control.removeValidators(Validators.required);
      }
      this.control.updateValueAndValidity();
    }
    ngOnDestroy() {
      if (this.disableOnDestroy) {
        this.control.disable();
      } else if (this.enableOnDestroy) {
        this.control.enable();
      }
      if (this.clearOnDestroy) {
        this.control.setValue(null);
      }
      super.ngOnDestroy();
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵInputBaseComponent_BaseFactory;
        return function InputBaseComponent_Factory(__ngFactoryType__) {
          return (ɵInputBaseComponent_BaseFactory || (ɵInputBaseComponent_BaseFactory = i0.ɵɵgetInheritedFactory(InputBaseComponent)))(__ngFactoryType__ || InputBaseComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputBaseComponent,
        selectors: [["ng-component"]],
        inputs: {
          id: "id",
          label: "label",
          logMissingLabel: [2, "logMissingLabel", "logMissingLabel", booleanAttribute],
          labelClass: "labelClass",
          readonly: [2, "readonly", "readonly", booleanAttribute],
          inputClass: "inputClass",
          wrapperClass: "wrapperClass",
          showRequiredStar: "showRequiredStar",
          customErrorMessage: "customErrorMessage",
          initWithValue: "initWithValue",
          setRequiredOnInit: [2, "setRequiredOnInit", "setRequiredOnInit", booleanAttribute],
          unsetRequiredOnDestroy: [2, "unsetRequiredOnDestroy", "unsetRequiredOnDestroy", booleanAttribute],
          enableOnInit: [2, "enableOnInit", "enableOnInit", booleanAttribute],
          disableOnInit: [2, "disableOnInit", "disableOnInit", booleanAttribute],
          enableOnDestroy: [2, "enableOnDestroy", "enableOnDestroy", booleanAttribute],
          disableOnDestroy: [2, "disableOnDestroy", "disableOnDestroy", booleanAttribute],
          clearOnDestroy: [2, "clearOnDestroy", "clearOnDestroy", booleanAttribute],
          _control: [0, "control", "_control"]
        },
        outputs: {
          change: "change",
          controlReplaced: "controlReplaced"
        },
        features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature],
        decls: 0,
        vars: 0,
        template: function InputBaseComponent_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return InputBaseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputNumberDirective = /*#__PURE__*/(() => {
  class InputNumberDirective {
    constructor(parent) {
      this.parent = parent;
      this.allowNegative = true; // determines if '-' is allowed. Prevents input of -
      this.minTotal = 0; // minimal total value including decimal, null sets no restrictions - if out of bounds an error is attached to the input
      this.maxTotal = null; // max total value including decimals, null sets no restrictions - if out of bounds an error is attached to the input
      this.maxDecimalPlaces = 2; // max allowed decimals - prevents adding more than specified
      this.addDecimalZerosPadding = false; // if decimals present -> add zeros to match max allowed decimals
      this.forceDecimals = false; // true -> 1 gets transformed to 1.00 (0-count according to maxDecimalPlaces)
      this.formatOnInit = false; // true -> format control initially in NgOnInit
      this.errorTextMinUndershot = 'Value must be at least {{val}}';
      this.errorTextMaxExceeded = 'The maximum value is {{val}}';
    }
    ngOnChanges() {
      if (this.formatOnInit) {
        this.ngOnInit();
      }
    }
    ngOnInit() {
      if (this.formatOnInit) {
        this.whenLeaving();
      }
    }
    selectWhenZero(event) {
      if (+this.parent.control.value === 0 && typeof event.target.select !== 'undefined') {
        event.target.select();
      }
    }
    // instant reaction on keypress
    transformValue(value) {
      if (this.parent.control) {
        value = '' + value;
        if (value.length > 11) {
          value = value.substr(0, 12);
        }
        if (!this.allowNegative && value.includes('-')) {
          this.parent.control.setValue(value.replace('-', ''));
          return;
        }
        if (value === '-0') {
          this.parent.control.setValue('0');
          return;
        }
        let amount = ('' + value).replace(',', '.');
        if (!this.maxDecimalPlaces) {
          amount = amount.replace('.', '');
        }
        const beforePoint = amount.split('.')[0];
        let integers = '';
        if (typeof beforePoint !== 'undefined' && beforePoint !== '') {
          integers = beforePoint.replace(/-?\D+/g, '');
          if (integers !== '') {
            integers = '' + parseInt(integers, 10);
          }
        }
        if (value && value.toString().startsWith('-')) {
          integers = '-' + integers;
        }
        const afterPoint = amount.split('.')[1];
        let decimals = '';
        if (typeof afterPoint !== 'undefined') {
          decimals = afterPoint.replace(/\D+/g, '');
        }
        if (decimals.length > this.maxDecimalPlaces) {
          decimals = decimals.slice(0, this.maxDecimalPlaces);
        }
        amount = integers;
        if (typeof afterPoint === 'string') {
          amount += '.';
        }
        if (decimals.length > 0) {
          amount += decimals;
        }
        this.parent.control.setValue(amount ?? null);
      }
    }
    // checking errors after leaving input or pressing enter
    whenLeaving() {
      if (!this.parent.control?.value) {
        return;
      }
      let val = '' + this.parent.control.value;
      if (!this.allowNegative) {
        val = val.replace('-', '');
      }
      const splitAtPoint = val.split('.');
      if (this.addDecimalZerosPadding && this.maxDecimalPlaces) {
        val = val + '0'.repeat(this.maxDecimalPlaces - splitAtPoint[1]?.length);
      }
      if (this.forceDecimals && !val.includes('.')) {
        val = val + '.' + '0'.repeat(this.maxDecimalPlaces);
      }
      if (val.endsWith('.')) {
        val = val.replace('.', '');
      }
      if (this.parent.control.value !== val) {
        this.parent.control.setValue(val);
      }
      if (this.minTotal !== null && this.minTotal > +val) {
        this.parent.control.setErrors({
          minUndershot: this.errorTextMinUndershot.replace('{{val}}', this.minTotal.toString())
        });
      } else {
        removeFormControlError(this.parent.control, 'minUndershot');
      }
      if (this.maxTotal !== null && this.maxTotal < +val) {
        this.parent.control.setErrors({
          maxExceeded: this.errorTextMaxExceeded.replace('{{val}}', this.maxTotal.toString())
        });
      } else {
        removeFormControlError(this.parent.control, 'maxExceeded');
      }
    }
    static {
      this.ɵfac = function InputNumberDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputNumberDirective)(i0.ɵɵdirectiveInject(InputBaseComponent));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: InputNumberDirective,
        selectors: [["", "inputNumber", ""]],
        hostBindings: function InputNumberDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function InputNumberDirective_click_HostBindingHandler($event) {
              return ctx.selectWhenZero($event);
            })("input", function InputNumberDirective_input_HostBindingHandler($event) {
              return ctx.transformValue($event.target.value);
            })("focusout", function InputNumberDirective_focusout_HostBindingHandler() {
              return ctx.whenLeaving();
            })("keyup.enter", function InputNumberDirective_keyup_enter_HostBindingHandler() {
              return ctx.whenLeaving();
            });
          }
        },
        inputs: {
          allowNegative: "allowNegative",
          minTotal: "minTotal",
          maxTotal: "maxTotal",
          maxDecimalPlaces: "maxDecimalPlaces",
          addDecimalZerosPadding: "addDecimalZerosPadding",
          forceDecimals: "forceDecimals",
          formatOnInit: "formatOnInit",
          errorTextMinUndershot: "errorTextMinUndershot",
          errorTextMaxExceeded: "errorTextMaxExceeded"
        },
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return InputNumberDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputNumberModule = /*#__PURE__*/(() => {
  class InputNumberModule {
    static {
      this.ɵfac = function InputNumberModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputNumberModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InputNumberModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return InputNumberModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputFieldMatchingDirective = /*#__PURE__*/(() => {
  class InputFieldMatchingDirective extends BaseDirective {
    constructor() {
      super(...arguments);
      this.errorTextNotMatching = 'input-error.matching';
      this.control = new FormControl(null);
      this.controlToMatchWith = new FormControl(null);
      this.valueChanges$ = [];
    }
    set _controlToMatchWith(value) {
      this.controlToMatchWith = value;
    }
    set _control(value) {
      this.control = value;
    }
    ngOnChanges(changes) {
      if (changes['control'] || changes['controlToMatchWith']) {
        this.ngOnInit();
      }
    }
    ngOnInit() {
      this.valueChanges$.forEach(s => s.unsubscribe());
      this.valueChanges$ = [];
      this.valueChanges$.push(...[this.control, this.controlToMatchWith].map(c => c.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
        if (this.control.value !== this.controlToMatchWith.value) {
          this.controlToMatchWith.setErrors({
            matching: this.errorTextNotMatching,
            ...this.controlToMatchWith.errors
          });
        } else {
          removeFormControlError(this.controlToMatchWith, 'matching');
        }
      })));
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵInputFieldMatchingDirective_BaseFactory;
        return function InputFieldMatchingDirective_Factory(__ngFactoryType__) {
          return (ɵInputFieldMatchingDirective_BaseFactory || (ɵInputFieldMatchingDirective_BaseFactory = i0.ɵɵgetInheritedFactory(InputFieldMatchingDirective)))(__ngFactoryType__ || InputFieldMatchingDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: InputFieldMatchingDirective,
        selectors: [["", "inputFieldsMatching", ""]],
        inputs: {
          errorTextNotMatching: "errorTextNotMatching",
          _controlToMatchWith: [0, "controlToMatchWith", "_controlToMatchWith"],
          _control: [0, "control", "_control"]
        },
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return InputFieldMatchingDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputFieldMatchingModule = /*#__PURE__*/(() => {
  class InputFieldMatchingModule {
    static {
      this.ɵfac = function InputFieldMatchingModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputFieldMatchingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InputFieldMatchingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return InputFieldMatchingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// eslint-disable-next-line no-shadow
var InputAutocomplete = /*#__PURE__*/function (InputAutocomplete) {
  InputAutocomplete["Off"] = "off";
  InputAutocomplete["Username"] = "username";
  InputAutocomplete["Email"] = "email";
  InputAutocomplete["Nickname"] = "nickname";
  InputAutocomplete["BirthdayDate"] = "bday";
  InputAutocomplete["BirthdayDay"] = "bday-day";
  InputAutocomplete["BirthdayMonth"] = "bday-month";
  InputAutocomplete["BirthdayYear"] = "bday-year";
  InputAutocomplete["Gender"] = "sex";
  InputAutocomplete["Telephone"] = "tel";
  InputAutocomplete["Url"] = "url";
  InputAutocomplete["Language"] = "language";
  InputAutocomplete["PasswordCurrent"] = "current-password";
  InputAutocomplete["PasswordNew"] = "new-password";
  InputAutocomplete["OneTimeCode"] = "one-time-code";
  /**
   * First & Last Name
   * @type {InputAutocomplete.AddressName}
   */
  InputAutocomplete["AddressName"] = "name";
  InputAutocomplete["AddressTitle"] = "honorific-prefix";
  InputAutocomplete["AddressFirstName"] = "given-name";
  InputAutocomplete["AddressFamilyName"] = "family-name";
  InputAutocomplete["AddressCompany"] = "organization";
  InputAutocomplete["AddressCity"] = "city";
  InputAutocomplete["AddressState"] = "state";
  /**
   * Street + Housenumber
   * @type {InputAutocomplete.AddressStreet}
   */
  InputAutocomplete["AddressStreet"] = "street-address";
  InputAutocomplete["AddressCountryCode"] = "country";
  InputAutocomplete["AddressCountry"] = "country-name";
  InputAutocomplete["AddressZip"] = "postal-code";
  /**
   * Street-name. These should only be present if the "street-address" is not present.
   * @type {InputAutocomplete.AddressLineStreetName}
   */
  InputAutocomplete["AddressLineStreetName"] = "address-line1";
  /**
   * Street-number. These should only be present if the "street-address" is not present.
   * @type {InputAutocomplete.AddressLineStreetNumber}
   */
  InputAutocomplete["AddressLineStreetNumber"] = "address-line2";
  /**
   * Street-addition. These should only be present if the "street-address" is not present.
   * @type {InputAutocomplete.AddressLineStreetAddition}
   */
  InputAutocomplete["AddressLineStreetAddition"] = "address-line3";
  /**
   * The first administrative level in the address.
   * This is typically the province in which the address is located. In the United States, this would be the state. In Switzerland, the canton. In the United Kingdom, the post town.
   * @type {InputAutocomplete.AddressLevel1}
   */
  InputAutocomplete["AddressLevel1"] = "address-level1";
  /**
   * The second administrative level, in addresses with at least two of them.
   * In countries with two administrative levels, this would typically be the city, town, village, or other locality in which the address is located.
   * @type {InputAutocomplete.AddressLevel2}
   */
  InputAutocomplete["AddressLevel2"] = "address-level2";
  /**
   * The third administrative level, in addresses with at least three administrative levels.
   * @type {InputAutocomplete.AddressLevel3}
   */
  InputAutocomplete["AddressLevel3"] = "address-level3";
  /**
   * The finest-grained administrative level, in addresses which have four levels.
   * @type {InputAutocomplete.AddressLevel4}
   */
  InputAutocomplete["AddressLevel4"] = "address-level4";
  return InputAutocomplete;
}(InputAutocomplete || {});
// eslint-disable-next-line no-shadow
var InputTypeEnum = /*#__PURE__*/function (InputTypeEnum) {
  InputTypeEnum["Button"] = "button";
  InputTypeEnum["Checkbox"] = "checkbox";
  InputTypeEnum["Color"] = "color";
  InputTypeEnum["Date"] = "date";
  InputTypeEnum["Email"] = "email";
  InputTypeEnum["File"] = "file";
  InputTypeEnum["Image"] = "image";
  InputTypeEnum["Month"] = "month";
  // eslint-disable-next-line id-blacklist
  InputTypeEnum["Number"] = "number";
  InputTypeEnum["Password"] = "password";
  InputTypeEnum["Radio"] = "radio";
  InputTypeEnum["Range"] = "range";
  InputTypeEnum["Reset"] = "reset";
  InputTypeEnum["Search"] = "search";
  InputTypeEnum["Submit"] = "submit";
  InputTypeEnum["Phone"] = "tel";
  InputTypeEnum["Text"] = "text";
  InputTypeEnum["Time"] = "time";
  InputTypeEnum["Url"] = "url";
  InputTypeEnum["Week"] = "week";
  return InputTypeEnum;
}(InputTypeEnum || {});
let InputErrorOutputComponent = /*#__PURE__*/(() => {
  class InputErrorOutputComponent {
    static {
      this.ɵfac = function InputErrorOutputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputErrorOutputComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputErrorOutputComponent,
        selectors: [["input-error-output"]],
        inputs: {
          control: "control",
          customErrorMessage: "customErrorMessage"
        },
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"], ["class", "text-danger", 4, "ngIf"], [1, "text-danger"], [4, "ngFor", "ngForOf"], ["class", "text-danger mb-0", 4, "ngIf"], [1, "text-danger", "mb-0"]],
        template: function InputErrorOutputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, InputErrorOutputComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", (ctx.control == null ? null : ctx.control.touched) && (ctx.control == null ? null : ctx.control.hasError) && (ctx.control == null ? null : ctx.control.errors));
          }
        },
        dependencies: [i1$1.NgForOf, i1$1.NgIf, i1$1.KeyValuePipe],
        styles: ["p.text-danger[_ngcontent-%COMP%]{margin-top:0}"]
      });
    }
  }
  return InputErrorOutputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputPasswordMeterComponent = /*#__PURE__*/(() => {
  class InputPasswordMeterComponent {
    constructor() {
      this.barLabel = 'Passwortstärke';
      this.bars = ['', '', '', '', ''];
      this.colors = ['#F00', '#F90', '#FF0', '#9F0', '#0F0'];
    }
    static measureStrength(pass) {
      let score = 0;
      // award every unique letter until 5 repetitions
      const letters = {};
      for (let i = 0; i < pass.length; i++) {
        letters[pass[i]] = (letters[pass[i]] || 0) + 1;
        score += 5.0 / letters[pass[i]];
      }
      // bonus points for mixing it up
      const variations = {
        digits: /\d/.test(pass),
        lower: /[a-z]/.test(pass),
        upper: /[A-Z]/.test(pass),
        nonWords: /\W/.test(pass)
      };
      let variationCount = 0;
      // eslint-disable-next-line guard-for-in
      for (const check in variations) {
        variationCount += variations[check] ? 1 : 0;
      }
      score += (variationCount - 1) * 10;
      return Math.trunc(score);
    }
    ngOnInit() {
      if (!this.passControl) {
        console.error('passcontrol not set for input-password-meter');
        return;
      }
      this.passControl.valueChanges.pipe(debounceTime(5)).subscribe(val => {
        this.setBarColors(5, '#DDD');
        if (val) {
          const c = this.getColor(InputPasswordMeterComponent.measureStrength(val));
          this.setBarColors(c.idx, c.col);
        }
      });
    }
    getColor(score) {
      let idx = 0;
      if (score > 90) {
        idx = 4;
      } else if (score > 70) {
        idx = 3;
      } else if (score >= 40) {
        idx = 2;
      } else if (score >= 20) {
        idx = 1;
      }
      return {
        idx: idx + 1,
        col: this.colors[idx]
      };
    }
    setBarColors(count, col) {
      for (let n = 0; n < count; n++) {
        this.bars[n] = col;
      }
    }
    static {
      this.ɵfac = function InputPasswordMeterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputPasswordMeterComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputPasswordMeterComponent,
        selectors: [["input-password-meter"]],
        inputs: {
          passControl: "passControl",
          barLabel: "barLabel"
        },
        decls: 6,
        vars: 2,
        consts: [["strength", ""], ["id", "strength", 2, "margin", "11px"], ["id", "strengthBar"], ["class", "point", 3, "background-color", 4, "ngFor", "ngForOf"], [1, "point"]],
        template: function InputPasswordMeterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1, 0)(2, "small");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "ul", 2);
            i0.ɵɵtemplate(5, InputPasswordMeterComponent_li_5_Template, 1, 2, "li", 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.barLabel);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.bars);
          }
        },
        dependencies: [i1$1.NgForOf],
        styles: ["ul#strengthBar[_ngcontent-%COMP%]{display:inline;list-style:none;margin:0 0 0 15px;padding:0;vertical-align:2px}.point[_ngcontent-%COMP%]:last-of-type{margin:0!important}.point[_ngcontent-%COMP%]{border:1px rgba(0,0,0,.0705882353) solid;background:#ddd;border-radius:2px;display:inline-block;height:5px;margin-right:1px;width:20px}"]
      });
    }
  }
  return InputPasswordMeterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputTextboxComponent = /*#__PURE__*/(() => {
  class InputTextboxComponent extends InputBaseComponent {
    constructor() {
      super();
      this.autocomplete = InputAutocomplete.Off;
      this.type = null;
      this.placeholder = '';
      this.showPasswordMeter = false;
      this.passwordMeterLabel = 'password-strength';
      this.capitalizeOnBlur = false;
      this.autofocusInput = false;
      this.suffixClicked = new EventEmitter();
      this.passwordVisible = false;
    }
    ngOnInit() {
      super.ngOnInit();
      if (this.addPattern) {
        this.control.addValidators(Validators.pattern(this.addPattern));
      }
      if (!this.type) {
        console.log('Textboxtype muss angegeben werden für ' + this.id);
      }
    }
    focus() {
      if (this.inputElement) {
        const element = this.inputElement.nativeElement;
        element.focus();
        element.select();
      }
    }
    whenLeaving() {
      const val = this.control.value;
      if (this.capitalizeOnBlur && val) {
        const first = val.charAt(0);
        if (first === first.toLowerCase() && first !== first.toUpperCase()) {
          this.control.setValue(first.toUpperCase() + val.slice(1));
        }
      }
    }
    static {
      this.ɵfac = function InputTextboxComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputTextboxComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputTextboxComponent,
        selectors: [["input-textbox"]],
        viewQuery: function InputTextboxComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c3, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
          }
        },
        hostBindings: function InputTextboxComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("focusout", function InputTextboxComponent_focusout_HostBindingHandler() {
              return ctx.whenLeaving();
            })("keyup.enter", function InputTextboxComponent_keyup_enter_HostBindingHandler() {
              return ctx.whenLeaving();
            });
          }
        },
        inputs: {
          autocomplete: "autocomplete",
          type: "type",
          placeholder: "placeholder",
          suffix: "suffix",
          suffixContainerClass: "suffixContainerClass",
          addPattern: "addPattern",
          showPasswordMeter: "showPasswordMeter",
          passwordMeterLabel: "passwordMeterLabel",
          capitalizeOnBlur: "capitalizeOnBlur",
          autofocusInput: "autofocusInput",
          autocapitalize: "autocapitalize"
        },
        outputs: {
          suffixClicked: "suffixClicked"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: InputBaseComponent,
          useExisting: forwardRef(() => InputTextboxComponent)
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 1,
        consts: [["input", ""], ["inputElement", ""], [3, "class", 4, "ngIf"], [1, "position-relative"], [3, "for", "innerHTML", 4, "ngIf"], [3, "ngTemplateOutlet", 4, "ngIf"], ["class", "input-group", 4, "ngIf"], ["class", "password-peek fa", 3, "fa-eye-slash", "fa-eye", "click", 4, "ngIf"], [3, "barLabel", "passControl", 4, "ngIf"], [3, "control", "customErrorMessage"], [3, "for", "innerHTML"], [3, "ngTemplateOutlet"], [1, "input-group"], [3, "click"], [1, "input-group-text", 3, "innerHtml"], [1, "password-peek", "fa", 3, "click"], [3, "barLabel", "passControl"], [3, "autocomplete", "formControl", "id", "placeholder", "readOnly", "type"]],
        template: function InputTextboxComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, InputTextboxComponent_div_0_Template, 8, 9, "div", 2)(1, InputTextboxComponent_ng_template_1_Template, 2, 12, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.control);
          }
        },
        dependencies: [i1$1.NgIf, i1$1.NgTemplateOutlet, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.FormControlDirective, InputErrorOutputComponent, InputPasswordMeterComponent, i1$1.AsyncPipe],
        styles: ["input[_ngcontent-%COMP%]{text-overflow:ellipsis}.password-peek[_ngcontent-%COMP%]{position:absolute;right:10px;bottom:7px;padding:3px;cursor:pointer}input.password-peek-padding[_ngcontent-%COMP%]{padding-right:2.5rem}input[readonly][_ngcontent-%COMP%]{cursor:not-allowed}.input-group-text[_ngcontent-%COMP%]{border-bottom-left-radius:0;border-top-left-radius:0}.form-control[_ngcontent-%COMP%]:focus{box-shadow:none}  input-textbox.fw-bold input{font-weight:700}  input-textbox.borderless input{border:none;border-radius:0;box-sizing:border-box;border-bottom:1px transparent solid;padding:0}  input-textbox.borderless input:focus{border-bottom-color:gray}  input-textbox.input-sm .input-group-text{height:31px}  input-textbox.input-sm input{box-shadow:none!important;height:31px}"]
      });
    }
  }
  return InputTextboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputFilterDirective = /*#__PURE__*/(() => {
  class InputFilterDirective {
    constructor(parent) {
      this.parent = parent;
      this.clearNotMatchingCharacters = true; // TODO implement case "false"
    }
    ngOnInit() {
      this.blur();
    }
    // instant reaction on keypress
    transformValue(val) {
      if (!this.validationRegex) {
        return;
      }
      this.parent.control.setValue(this.transform(val));
    }
    blur() {
      this.transformValue(this.parent.control.value);
    }
    transform(value) {
      return value.replace(this.validationRegex, '');
    }
    static {
      this.ɵfac = function InputFilterDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputFilterDirective)(i0.ɵɵdirectiveInject(InputTextboxComponent));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: InputFilterDirective,
        selectors: [["input-textbox", "inputFilter", ""]],
        hostBindings: function InputFilterDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("input", function InputFilterDirective_input_HostBindingHandler($event) {
              return ctx.transformValue($event.target.value);
            })("focusout", function InputFilterDirective_focusout_HostBindingHandler() {
              return ctx.blur();
            })("keyup.enter", function InputFilterDirective_keyup_enter_HostBindingHandler() {
              return ctx.blur();
            });
          }
        },
        inputs: {
          validationRegex: "validationRegex",
          clearNotMatchingCharacters: "clearNotMatchingCharacters",
          errorOnNotMatchingCharacters: "errorOnNotMatchingCharacters"
        }
      });
    }
  }
  return InputFilterDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputFilterModule = /*#__PURE__*/(() => {
  class InputFilterModule {
    static {
      this.ɵfac = function InputFilterModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputFilterModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InputFilterModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return InputFilterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputCheckboxComponent = /*#__PURE__*/(() => {
  class InputCheckboxComponent extends InputBaseComponent {
    constructor() {
      super();
      this.labelAfterCheckbox = true;
      this.cbCheckedValue = true;
      this.cbUncheckedValue = false;
      this.initialChecked = false;
      this.setRequiredTrueOnInit = false; // sets reqTrue.Validator in OnInit
      this.unsetRequiredTrueOnDestroy = false; // unsets reqTrue.Validator in OnDestroy
      this.checked = new EventEmitter();
      this.unchecked = new EventEmitter();
    }
    ngOnInit() {
      super.ngOnInit();
      this.change.subscribe(val => {
        if (val === this.cbCheckedValue) {
          this.checked.emit(this.cbCheckedValue);
        } else if (val === this.cbUncheckedValue) {
          this.unchecked.emit(this.cbUncheckedValue);
        }
      });
      if (this.initialChecked) {
        this.control.setValue(this.cbCheckedValue);
      }
      if (this.setRequiredTrueOnInit) {
        this.setRequiredTrueState(true);
      }
    }
    ngOnDestroy() {
      super.ngOnDestroy();
      if (this.unsetRequiredTrueOnDestroy) {
        this.setRequiredTrueState(false);
      }
    }
    setRequiredTrueState(required) {
      if (required && !this.control.hasValidator(Validators.requiredTrue)) {
        this.control.addValidators(Validators.requiredTrue);
      } else if (!required && this.control.hasValidator(Validators.requiredTrue)) {
        this.control.removeValidators(Validators.requiredTrue);
      }
      this.control.updateValueAndValidity();
    }
    static {
      this.ɵfac = function InputCheckboxComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputCheckboxComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputCheckboxComponent,
        selectors: [["input-checkbox"]],
        inputs: {
          labelAfterCheckbox: "labelAfterCheckbox",
          cbCheckedValue: "cbCheckedValue",
          cbUncheckedValue: "cbUncheckedValue",
          initialChecked: "initialChecked",
          setRequiredTrueOnInit: "setRequiredTrueOnInit",
          unsetRequiredTrueOnDestroy: "unsetRequiredTrueOnDestroy"
        },
        outputs: {
          checked: "checked",
          unchecked: "unchecked"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 8,
        vars: 24,
        consts: [[1, "custom-checkbox", 3, "click", "id"], [1, "fa", "custom-control-indicator", "text-start"], [3, "innerHTML"], ["class", "d-inline-block", 4, "ngIf"], [1, "d-inline-block"]],
        template: function InputCheckboxComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "label", 0);
            i0.ɵɵlistener("click", function InputCheckboxComponent_Template_label_click_1_listener() {
              return !ctx.readonly && ctx.control.enabled && ctx.control.setValue(ctx.control.value === ctx.cbCheckedValue ? ctx.cbUncheckedValue : ctx.cbCheckedValue);
            });
            i0.ɵɵelement(2, "span", 1);
            i0.ɵɵelementStart(3, "div");
            i0.ɵɵelement(4, "span", 2);
            i0.ɵɵpipe(5, "safe");
            i0.ɵɵtemplate(6, InputCheckboxComponent_em_6_Template, 2, 0, "em", 3);
            i0.ɵɵpipe(7, "async");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.wrapperClass + " text-start d-inline-block");
            i0.ɵɵclassProp("disabled", ctx.control.disabled)("readonly", ctx.readonly);
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", ctx.id + "_checkbox");
            i0.ɵɵadvance();
            i0.ɵɵclassProp("checked", ctx.control.value === ctx.cbCheckedValue)("fa-check", ctx.control.value == ctx.cbCheckedValue)("ng-invalid", ctx.control.invalid)("ng-touched", ctx.control.touched);
            i0.ɵɵadvance();
            i0.ɵɵclassMap("custom-control-description d-inline-block " + ctx.labelClass);
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(5, 19, ctx.label, "html"), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 22, ctx.controlIsRequired$) && ctx.showRequiredStar);
          }
        },
        dependencies: [i1$1.NgIf, i1$1.AsyncPipe, SafePipe],
        styles: ["em[_ngcontent-%COMP%]{color:red}.ng-touched.ng-invalid[_ngcontent-%COMP%]{border:1px solid #FF4A55!important;box-shadow:0 0 4px #ff4a55}.disabled[_ngcontent-%COMP%], .readonly[_ngcontent-%COMP%]{opacity:.65}.disabled[_ngcontent-%COMP%]   *[_ngcontent-%COMP%], .readonly[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{cursor:default!important;pointer-events:none}.custom-checkbox[_ngcontent-%COMP%]{position:relative;display:block;min-height:1.5rem;padding-left:1.8rem;margin-right:1rem;cursor:pointer}.custom-checkbox[_ngcontent-%COMP%]   .custom-control-description[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{text-transform:none;font-size:13px;margin-left:8px}.custom-checkbox[_ngcontent-%COMP%]   .custom-control-indicator[_ngcontent-%COMP%]{z-index:1;font-size:12px;position:absolute;top:2px;left:0;display:block;height:20px;width:20px;margin-right:5px;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-radius:.25rem;background-color:#fff;background-repeat:no-repeat;background-position:center center;background-size:50% 50%}.custom-checkbox[_ngcontent-%COMP%]   .custom-control-indicator[_ngcontent-%COMP%]:not(.checked){border:1px solid #c1c1c1}.custom-checkbox[_ngcontent-%COMP%]   .custom-control-indicator.checked[_ngcontent-%COMP%]{color:#fff;background-color:var(--color-primary)}.custom-checkbox[_ngcontent-%COMP%]   .custom-control-indicator.fa-check[_ngcontent-%COMP%]{padding-left:4px;padding-top:4px}.custom-checkbox[_ngcontent-%COMP%]:active   .custom-control-indicator[_ngcontent-%COMP%]{color:#fff;background-color:var(--color-primary)}.custom-checkbox[_ngcontent-%COMP%]:hover   .custom-control-indicator[_ngcontent-%COMP%]:not(.checked):not(.readonly){border-color:var(--color-primary-dark)}  input-checkbox{display:block}"]
      });
    }
  }
  return InputCheckboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputSharedModule = /*#__PURE__*/(() => {
  class InputSharedModule {
    static {
      this.ɵfac = function InputSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputSharedModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InputSharedModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [FormsModule, ReactiveFormsModule, TranslateModule, CommonModule, FormsModule, ReactiveFormsModule, TranslateModule]
      });
    }
  }
  return InputSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputCheckboxModule = /*#__PURE__*/(() => {
  class InputCheckboxModule {
    static {
      this.ɵfac = function InputCheckboxModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputCheckboxModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InputCheckboxModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, InputSharedModule, SafePipeModule]
      });
    }
  }
  return InputCheckboxModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputDatepickerComponent = /*#__PURE__*/(() => {
  class InputDatepickerComponent extends InputBaseComponent {
    constructor() {
      super(...arguments);
      this.dateNow = new Date();
      this.appendTo = 'body';
      this.dateFormat = 'dd.mm.yy';
      this.autocomplete = InputAutocomplete.Off;
      this.disabledDays = [];
      this.readonlyInput = true; // prevent typing - only selecting allowed
      this.view = 'date';
      this.showTime = false;
      this.maxDateNow = false; // max selectable date = now - sets yearrange-max to current year
      this.showYearNavigator = true;
      this.yearRangeMin = 1900;
      this.yearRangeMax = 2050;
    }
    ngOnInit() {
      super.ngOnInit();
      if (typeof this.control.value === 'string') {
        this.value = new Date(this.control.value);
      }
      if (this.maxDateNow) {
        this.yearRangeMax = this.dateNow.getFullYear();
      }
      // TODO - deprecated
      this.de = {
        firstDayOfWeek: 1,
        dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
        dayNamesShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
        dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
        today: 'Heute',
        clear: 'leeren',
        dateFormat: 'dd.mm.yy',
        weekHeader: 'KW'
      };
      merge(this.control.valueChanges, this.controlReplaced.pipe(map(() => this.control.value))).pipe(takeUntil(this.ngUnsubscribe)).subscribe(v => {
        // TODO check why we need this this.control.markAsTouched();
        if (!v) {
          this.value = undefined;
        }
      });
    }
    setValue() {
      setTimeout(() => {
        this.control.setValue(typeof this.value?.getMonth === 'function' ? new Date(this.value).toISOString() : undefined);
      }, 100);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵInputDatepickerComponent_BaseFactory;
        return function InputDatepickerComponent_Factory(__ngFactoryType__) {
          return (ɵInputDatepickerComponent_BaseFactory || (ɵInputDatepickerComponent_BaseFactory = i0.ɵɵgetInheritedFactory(InputDatepickerComponent)))(__ngFactoryType__ || InputDatepickerComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputDatepickerComponent,
        selectors: [["input-datepicker"]],
        viewQuery: function InputDatepickerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c4, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calendar = _t.first);
          }
        },
        inputs: {
          appendTo: "appendTo",
          dateFormat: "dateFormat",
          placeholder: "placeholder",
          autocomplete: "autocomplete",
          disabledDays: "disabledDays",
          readonlyInput: "readonlyInput",
          view: "view",
          showTime: "showTime",
          maxDateNow: "maxDateNow",
          showYearNavigator: "showYearNavigator",
          yearRangeMin: "yearRangeMin",
          yearRangeMax: "yearRangeMax"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 10,
        vars: 29,
        consts: [["calendar", ""], [3, "for"], ["class", "text-danger", 4, "ngIf"], [1, "input-group"], ["icon", "fa fa-calendar", 3, "onSelect", "onClearClick", "ngModelChange", "appendTo", "ngModel", "dateFormat", "disabledDays", "id", "inputStyleClass", "inputStyle", "monthNavigator", "readonlyInput", "placeholder", "showIcon", "showButtonBar", "showTime", "view", "yearNavigator", "yearRange"], [4, "ngIf"], [3, "control"], [1, "text-danger"], [1, "row"], [1, "col-12", "text-center", "mb-3"], [1, "btn", "btn-primary", 3, "click"]],
        template: function InputDatepickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div")(1, "label", 1);
            i0.ɵɵtext(2);
            i0.ɵɵtemplate(3, InputDatepickerComponent_em_3_Template, 2, 0, "em", 2);
            i0.ɵɵpipe(4, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 3)(6, "p-calendar", 4, 0);
            i0.ɵɵlistener("onSelect", function InputDatepickerComponent_Template_p_calendar_onSelect_6_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.setValue());
            })("onClearClick", function InputDatepickerComponent_Template_p_calendar_onClearClick_6_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.control.setValue(null));
            });
            i0.ɵɵtwoWayListener("ngModelChange", function InputDatepickerComponent_Template_p_calendar_ngModelChange_6_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.value, $event) || (ctx.value = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵtemplate(8, InputDatepickerComponent_p_footer_8_Template, 5, 0, "p-footer", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(9, "input-error-output", 6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_15_0;
            const calendar_r3 = i0.ɵɵreference(7);
            i0.ɵɵclassMap(ctx.wrapperClass + " text-start");
            i0.ɵɵadvance();
            i0.ɵɵproperty("for", ctx.id + "_input");
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 25, ctx.controlIsRequired$) && ctx.showRequiredStar);
            i0.ɵɵadvance(3);
            i0.ɵɵstyleMap(i0.ɵɵpureFunction0(27, _c5));
            i0.ɵɵproperty("appendTo", ctx.appendTo);
            i0.ɵɵtwoWayProperty("ngModel", ctx.value);
            i0.ɵɵproperty("dateFormat", ctx.dateFormat)("disabledDays", ctx.disabledDays)("id", ctx.id + "_input")("inputStyleClass", ctx.control.invalid && ctx.control.touched ? "ng-invalid ng-touched" : "")("inputStyle", i0.ɵɵpureFunction0(28, _c6))("monthNavigator", true)("readonlyInput", ctx.readonlyInput)("placeholder", (tmp_15_0 = ctx.placeholder) !== null && tmp_15_0 !== undefined ? tmp_15_0 : "")("showIcon", true)("showButtonBar", true)("showTime", ctx.showTime)("view", ctx.view)("yearNavigator", ctx.showYearNavigator)("yearRange", ctx.yearRangeMin + ":" + ctx.yearRangeMax);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", calendar_r3.showTime);
            i0.ɵɵadvance();
            i0.ɵɵproperty("control", ctx.control);
          }
        },
        dependencies: [i1$1.NgIf, i2$1.NgControlStatus, i2$1.NgModel, InputErrorOutputComponent, i4.Calendar, i5.Footer, i1$1.AsyncPipe],
        styles: ["p-calendar .p-inputtext{background:#fff}"]
      });
    }
  }
  return InputDatepickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputDatepickerModule = /*#__PURE__*/(() => {
  class InputDatepickerModule {
    static {
      this.ɵfac = function InputDatepickerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputDatepickerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InputDatepickerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, InputSharedModule, CalendarModule]
      });
    }
  }
  return InputDatepickerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputDropdownComponent = /*#__PURE__*/(() => {
  class InputDropdownComponent extends InputBaseComponent {
    constructor(translateService) {
      super();
      this.translateService = translateService;
      this.autocomplete = InputAutocomplete.Off; // TODO
      this.appendTo = 'body';
      this.minItemsForFilter = 10; // false = do not show filter
      this.items = [];
      this.translateItems = true;
      this.editable = false; // enables writing own text
      this.dropdownIcon = 'fa fa-fw fa-caret-down';
      this.dropdownIconWhenOpened = 'fa fa-fw fa-caret-up';
      this.onSelect = new EventEmitter();
      this.itemsForTemplate = [];
    }
    // TODO merge duplicate code with input-multiselect - helpermethod?
    ngOnInit() {
      super.ngOnInit();
      this.setItems();
      this.translateService.onLangChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => this.setItems());
      merge(of(this.control.value), this.change).pipe(takeUntil(this.ngUnsubscribe)).subscribe(val => {
        this.selectedItem = this.items ? this.items.find(p => p.value === val) : null;
      });
    }
    ngOnChanges(changes) {
      if (changes['items'] || changes['includePleaseSelect']) {
        this.setItems();
      }
    }
    openDropdown(event) {
      event.stopPropagation();
      if (this.elRef) {
        this.elRef.show();
      }
    }
    // TODO merge duplicate code with input-multiselect - helpermethod?
    setItems() {
      const translation = this.translateService.translations[this.translateService.currentLang];
      if (!translation) {
        return;
      }
      const items = this.translateItems ? this.items.map(i => {
        const path = i.label.split('.').reverse();
        let part = path.pop();
        let translatedLabel = translation[part];
        while (path.length && translatedLabel) {
          part = path.pop();
          translatedLabel = translatedLabel[part];
        }
        return {
          value: i.value,
          label: translatedLabel ?? this.translateService.instant(i.label),
          disabled: !i.disabled ? false : i.disabled
        };
      }) : this.items;
      if (this.pleaseSelectLabel?.length) {
        this.itemsForTemplate = [{
          value: null,
          label: this.pleaseSelectLabel,
          disabled: true
        }, ...items];
      } else {
        this.itemsForTemplate = items;
      }
    }
    static {
      this.ɵfac = function InputDropdownComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputDropdownComponent)(i0.ɵɵdirectiveInject(i1$3.TranslateService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputDropdownComponent,
        selectors: [["input-dropdown"]],
        viewQuery: function InputDropdownComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c7, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.elRef = _t.first);
          }
        },
        inputs: {
          autocomplete: "autocomplete",
          appendTo: "appendTo",
          minItemsForFilter: "minItemsForFilter",
          pleaseSelectLabel: "pleaseSelectLabel",
          items: "items",
          translateItems: "translateItems",
          editable: "editable",
          placeholder: "placeholder",
          dropdownIcon: "dropdownIcon",
          dropdownIconWhenOpened: "dropdownIconWhenOpened"
        },
        outputs: {
          onSelect: "onSelect"
        },
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        decls: 5,
        vars: 19,
        consts: [["dropdown", ""], [3, "for", "click", 4, "ngIf"], [3, "onChange", "onHide", "onShow", "appendTo", "dropdownIcon", "editable", "filter", "formControl", "inputId", "options", "placeholder", "readonly"], [3, "control"], [3, "click", "for"], ["class", "text-danger", 4, "ngIf"], [1, "text-danger"]],
        template: function InputDropdownComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, InputDropdownComponent_label_1_Template, 4, 5, "label", 1);
            i0.ɵɵelementStart(2, "p-dropdown", 2, 0);
            i0.ɵɵlistener("onChange", function InputDropdownComponent_Template_p_dropdown_onChange_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSelect.emit($event));
            })("onHide", function InputDropdownComponent_Template_p_dropdown_onHide_2_listener() {
              i0.ɵɵrestoreView(_r1);
              const dropdown_r4 = i0.ɵɵreference(3);
              return i0.ɵɵresetView(dropdown_r4.dropdownIcon = ctx.dropdownIcon);
            })("onShow", function InputDropdownComponent_Template_p_dropdown_onShow_2_listener() {
              i0.ɵɵrestoreView(_r1);
              const dropdown_r4 = i0.ɵɵreference(3);
              return i0.ɵɵresetView(dropdown_r4.dropdownIcon = ctx.dropdownIconWhenOpened);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "input-error-output", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_13_0;
            i0.ɵɵclassMap(ctx.wrapperClass + " text-start pdropdownwrapper");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label && ctx.label.length);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.inputClass);
            i0.ɵɵclassProp("disabled", ctx.control == null ? null : ctx.control.disabled)("readonly", ctx.readonly);
            i0.ɵɵproperty("appendTo", ctx.appendTo)("dropdownIcon", ctx.dropdownIcon)("editable", ctx.editable)("filter", ctx.minItemsForFilter !== false && ctx.itemsForTemplate.length >= ctx.minItemsForFilter)("formControl", ctx.control)("inputId", ctx.id + "_input")("options", ctx.itemsForTemplate)("placeholder", (tmp_13_0 = ctx.placeholder) !== null && tmp_13_0 !== undefined ? tmp_13_0 : "")("readonly", ctx.readonly);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("control", ctx.control);
          }
        },
        dependencies: [i1$1.NgIf, i2$1.NgControlStatus, i2$1.FormControlDirective, InputErrorOutputComponent, i5$1.Dropdown, i1$1.AsyncPipe],
        styles: ["input-dropdown.input-sm p-dropdown{font-size:.8rem}  input-dropdown.input-sm p-dropdown .p-dropdown-panel{top:28px}  input-dropdown.input-sm p-dropdown *{font-size:.8rem}  input-dropdown .pdropdownwrapper p-dropdown{padding:0}  input-dropdown .pdropdownwrapper p-dropdown.readonly{background-color:#e9ecef}  input-dropdown .pdropdownwrapper p-dropdown.readonly *{cursor:not-allowed}  input-dropdown .pdropdownwrapper p-dropdown div.p-dropdown{width:100%;background:transparent;border:none;padding-left:8px;outline:none!important;box-shadow:none!important}  input-dropdown .pdropdownwrapper p-dropdown .p-dropdown-trigger{background:transparent}  input-dropdown .pdropdownwrapper p-dropdown .p-dropdown-filter{color:#000!important}  input-dropdown.borderless p-dropdown{border:none}  input-dropdown.borderless p-dropdown .p-dropdown input{border:none;border-radius:0;box-sizing:border-box;border-bottom:1px transparent solid;padding:0;transition:border-color .15s ease-in-out}  input-dropdown.borderless p-dropdown .p-dropdown input:focus{box-shadow:none!important;border-bottom-color:gray}"]
      });
    }
  }
  return InputDropdownComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputDropdownModule = /*#__PURE__*/(() => {
  class InputDropdownModule {
    static {
      this.ɵfac = function InputDropdownModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputDropdownModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InputDropdownModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, InputSharedModule, DropdownModule]
      });
    }
  }
  return InputDropdownModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputFileComponent = /*#__PURE__*/(() => {
  class InputFileComponent extends InputBaseComponent {
    constructor() {
      super();
      this.fileNameEmitter = new EventEmitter();
      this.infoEmitter = new EventEmitter();
      this.acceptTypes = '*';
      this.maxSizeInMB = 2;
      this.multipleFiles = false;
    }
    // TODO translations
    // click on fileupload-button
    handleFileInput(target) {
      const file = target.files.item(0);
      if (!file) {
        return;
      } else if (file.size > this.maxSizeInMB * 1048576) {
        this.infoEmitter.next({
          message: 'Es dürfen nur Dateien mit max. 1MB hochgeladen werden. Datei zu groß',
          error: true
        });
        return;
      } /* else if (!file.type.includes('image/')) {
        this.toastr.error('Es dürfen nur Bilder hochgeladen werden.', 'Ungültiges Format');
        return;
        }*/
      this.fileName = 'Lade...';
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.fileName = file.name;
        if (reader?.result) {
          this.control.setValue(reader.result.toString().split('base64,')[1]);
          this.control.markAsDirty();
        }
      };
    }
    static {
      this.ɵfac = function InputFileComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputFileComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputFileComponent,
        selectors: [["input-file"]],
        inputs: {
          selectFileText: "selectFileText",
          acceptTypes: "acceptTypes",
          maxSizeInMB: "maxSizeInMB",
          multipleFiles: "multipleFiles"
        },
        outputs: {
          fileNameEmitter: "fileNameEmitter",
          infoEmitter: "infoEmitter"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 8,
        vars: 6,
        consts: [["fileInput", ""], ["type", "file", 1, "d-none", 3, "change", "accept"], ["type", "button", 1, "ml-5", "btn", "btn-fill", "btn-sm", "btn-primary", 3, "click", "disabled"], [1, "fa", "fa-cloud-upload"], ["class", "ms-3", 3, "text-danger", 4, "ngIf"], ["class", "ms-3", 4, "ngIf"], [1, "ms-3"]],
        template: function InputFileComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtext(0);
            i0.ɵɵelementStart(1, "input", 1, 0);
            i0.ɵɵlistener("change", function InputFileComponent_Template_input_change_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleFileInput($event.target));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "button", 2);
            i0.ɵɵlistener("click", function InputFileComponent_Template_button_click_3_listener() {
              i0.ɵɵrestoreView(_r1);
              const fileInput_r2 = i0.ɵɵreference(2);
              return i0.ɵɵresetView(fileInput_r2.click());
            });
            i0.ɵɵelement(4, "i", 3);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, InputFileComponent_small_6_Template, 2, 2, "small", 4)(7, InputFileComponent_small_7_Template, 2, 1, "small", 5);
          }
          if (rf & 2) {
            let tmp_4_0;
            i0.ɵɵtextInterpolate1("", ctx.label, "\n");
            i0.ɵɵadvance();
            i0.ɵɵproperty("accept", ctx.acceptTypes);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.control.disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", (tmp_4_0 = ctx.selectFileText) !== null && tmp_4_0 !== undefined ? tmp_4_0 : "", "\n");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.fileName);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.fileName);
          }
        },
        dependencies: [i1$1.NgIf]
      });
    }
  }
  return InputFileComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputFileModule = /*#__PURE__*/(() => {
  class InputFileModule {
    static {
      this.ɵfac = function InputFileModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputFileModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InputFileModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, InputSharedModule]
      });
    }
  }
  return InputFileModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputMultiselectComponent = /*#__PURE__*/(() => {
  class InputMultiselectComponent extends InputBaseComponent {
    constructor(translateService) {
      super();
      this.translateService = translateService;
      this.showToggleAll = false;
      this.placeholder = '';
      this.minItemsForFilter = 6; // false = do not show filter
      this.items = [];
      this.translateItems = true;
      this.itemsForTemplate = [];
    }
    // TODO merge duplicate code with input-dropdown - helpermethod?
    ngOnInit() {
      super.ngOnInit();
      this.setItems();
      this.translateService.onLangChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => this.setItems());
      // TODO fix for multiple values
      merge(of(this.control.value), this.change).pipe(takeUntil(this.ngUnsubscribe)).subscribe(val => {
        this.selectedItem = this.items ? this.items.find(p => p.value === val) : null;
      });
    }
    ngOnChanges(changes) {
      if (changes['items'] || changes['includePleaseSelect']) {
        this.setItems();
      }
    }
    openDropdown(event) {
      event.stopPropagation();
      if (this.elRef) {
        this.elRef.show();
      }
    }
    // TODO merge duplicate code with input-dropdown - helpermethod?
    setItems() {
      const translation = this.translateService.translations[this.translateService.currentLang];
      if (!translation) {
        return;
      }
      const items = this.translateItems ? this.items.map(i => {
        const path = i.label.split('.').reverse();
        let part = path.pop();
        let translatedLabel = translation[part];
        while (path.length && translatedLabel) {
          part = path.pop();
          translatedLabel = translatedLabel[part];
        }
        return {
          value: i.value,
          label: translatedLabel ?? this.translateService.instant(i.label),
          disabled: !i.disabled ? false : i.disabled
        };
      }) : this.items;
      if (this.pleaseSelectLabel?.length) {
        this.itemsForTemplate = [{
          value: null,
          label: this.pleaseSelectLabel,
          disabled: true
        }, ...items];
      } else {
        this.itemsForTemplate = items;
      }
    }
    static {
      this.ɵfac = function InputMultiselectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputMultiselectComponent)(i0.ɵɵdirectiveInject(i1$3.TranslateService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputMultiselectComponent,
        selectors: [["input-multiselect"]],
        viewQuery: function InputMultiselectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c7, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.elRef = _t.first);
          }
        },
        inputs: {
          showToggleAll: "showToggleAll",
          placeholder: "placeholder",
          minItemsForFilter: "minItemsForFilter",
          pleaseSelectLabel: "pleaseSelectLabel",
          items: "items",
          translateItems: "translateItems",
          appendTo: "appendTo"
        },
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        decls: 5,
        vars: 20,
        consts: [["multiSelect", ""], [3, "for", "click", 4, "ngIf"], [3, "onPanelHide", "onPanelShow", "appendTo", "dropdownIcon", "filter", "formControl", "inputId", "options", "placeholder", "readonly", "showHeader", "showToggleAll"], [3, "control"], [3, "click", "for"], ["class", "text-danger", 4, "ngIf"], [1, "text-danger"]],
        template: function InputMultiselectComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, InputMultiselectComponent_label_1_Template, 4, 5, "label", 1);
            i0.ɵɵelementStart(2, "p-multiSelect", 2, 0);
            i0.ɵɵlistener("onPanelHide", function InputMultiselectComponent_Template_p_multiSelect_onPanelHide_2_listener() {
              i0.ɵɵrestoreView(_r1);
              const multiSelect_r4 = i0.ɵɵreference(3);
              return i0.ɵɵresetView(multiSelect_r4.dropdownIcon = "fa fa-fw fa-caret-down");
            })("onPanelShow", function InputMultiselectComponent_Template_p_multiSelect_onPanelShow_2_listener() {
              i0.ɵɵrestoreView(_r1);
              const multiSelect_r4 = i0.ɵɵreference(3);
              return i0.ɵɵresetView(multiSelect_r4.dropdownIcon = "fa fa-fw fa-caret-up");
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "input-error-output", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.wrapperClass + " text-start pmultiselectwrapper");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label && ctx.label.length);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.inputClass);
            i0.ɵɵclassProp("disabled", ctx.control == null ? null : ctx.control.disabled)("readonly", ctx.readonly);
            i0.ɵɵproperty("appendTo", ctx.appendTo)("dropdownIcon", "fa fa-fw fa-caret-down")("filter", ctx.minItemsForFilter !== false && ctx.itemsForTemplate.length >= ctx.minItemsForFilter)("formControl", ctx.control)("inputId", ctx.id + "_input")("options", ctx.itemsForTemplate)("placeholder", ctx.placeholder)("readonly", ctx.readonly)("showHeader", ctx.minItemsForFilter !== false && ctx.itemsForTemplate.length >= ctx.minItemsForFilter || ctx.showToggleAll)("showToggleAll", ctx.showToggleAll);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("control", ctx.control);
          }
        },
        dependencies: [i1$1.NgIf, i2$1.NgControlStatus, i2$1.FormControlDirective, InputErrorOutputComponent, i5$2.MultiSelect, i1$1.AsyncPipe],
        styles: [".pmultiselectwrapper p-multiSelect{padding:0}  .pmultiselectwrapper p-multiSelect.readonly{background-color:#e9ecef}  .pmultiselectwrapper p-multiSelect.readonly *{cursor:not-allowed}  .pmultiselectwrapper p-multiSelect .p-highlight,   .pmultiselectwrapper p-multiSelect .p-multiselect-item:focus{box-shadow:none!important}  .pmultiselectwrapper p-multiSelect .pi{display:inline-block;font: 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased}  .pmultiselectwrapper p-multiSelect .pi.pi-times:before{content:\"\\f00d\"}  .pmultiselectwrapper p-multiSelect .pi.pi-check:before{content:\"\\f00c\"}  .pmultiselectwrapper p-multiSelect div.p-multiselect{width:100%;background:transparent;border:none;padding-left:8px;outline:none!important;box-shadow:none!important}  .pmultiselectwrapper p-multiSelect .p-multiselect-trigger{background:transparent}  .pmultiselectwrapper p-multiSelect .p-multiselect-filter{color:#000!important}"]
      });
    }
  }
  return InputMultiselectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputMultiselectModule = /*#__PURE__*/(() => {
  class InputMultiselectModule {
    static {
      this.ɵfac = function InputMultiselectModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputMultiselectModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InputMultiselectModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, InputSharedModule, MultiSelectModule]
      });
    }
  }
  return InputMultiselectModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputTextareaComponent = /*#__PURE__*/(() => {
  class InputTextareaComponent extends InputBaseComponent {
    constructor() {
      super();
      this.placeholder = '';
      this.rows = 3;
    }
    ngOnInit() {
      super.ngOnInit();
    }
    static {
      this.ɵfac = function InputTextareaComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputTextareaComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputTextareaComponent,
        selectors: [["input-textarea"]],
        inputs: {
          placeholder: "placeholder",
          rows: "rows"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 11,
        consts: [[3, "for", 4, "ngIf"], [3, "formControl", "id", "placeholder", "readonly", "rows"], [3, "control"], [3, "for"], ["class", "text-danger", 4, "ngIf"], [1, "text-danger"]],
        template: function InputTextareaComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, InputTextareaComponent_label_1_Template, 4, 5, "label", 0);
            i0.ɵɵelementStart(2, "textarea", 1);
            i0.ɵɵtext(3, "  ");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "input-error-output", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.wrapperClass + " text-start");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label && ctx.label.length);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.inputClass);
            i0.ɵɵproperty("formControl", ctx.control)("id", ctx.id + "_input")("placeholder", ctx.placeholder)("readonly", ctx.readonly)("rows", ctx.rows);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("control", ctx.control);
          }
        },
        dependencies: [i1$1.NgIf, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.FormControlDirective, InputErrorOutputComponent, i1$1.AsyncPipe],
        styles: ["textarea[_ngcontent-%COMP%]{min-height:38px;max-height:500px}"]
      });
    }
  }
  return InputTextareaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputTextareaModule = /*#__PURE__*/(() => {
  class InputTextareaModule {
    static {
      this.ɵfac = function InputTextareaModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputTextareaModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InputTextareaModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, InputSharedModule]
      });
    }
  }
  return InputTextareaModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputTextboxModule = /*#__PURE__*/(() => {
  class InputTextboxModule {
    static {
      this.ɵfac = function InputTextboxModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputTextboxModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InputTextboxModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, InputSharedModule]
      });
    }
  }
  return InputTextboxModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputTreeselectComponent = /*#__PURE__*/(() => {
  class InputTreeselectComponent extends InputBaseComponent {
    constructor() {
      super();
      this.appendTo = 'body';
      this.placeholder = '';
      this.items = [];
      this.selectionMode = 'single';
      this.emptyMessage = 'No entries found.';
      this.showFilter = false; // false = do not show filter
    }
    ngOnInit() {
      super.ngOnInit();
    }
    static {
      this.ɵfac = function InputTreeselectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputTreeselectComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputTreeselectComponent,
        selectors: [["input-treeselect"]],
        viewQuery: function InputTreeselectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(TreeSelect, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nativeElement = _t.first);
          }
        },
        inputs: {
          appendTo: "appendTo",
          placeholder: "placeholder",
          items: "items",
          selectionMode: "selectionMode",
          emptyMessage: "emptyMessage",
          showFilter: "showFilter"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 4,
        vars: 18,
        consts: [[3, "for", 4, "ngIf"], [3, "appendTo", "formControl", "id", "options", "filter", "emptyMessage", "placeholder", "selectionMode"], [3, "control"], [3, "for"], ["class", "text-danger", 4, "ngIf"], [1, "text-danger"]],
        template: function InputTreeselectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, InputTreeselectComponent_label_1_Template, 4, 5, "label", 0);
            i0.ɵɵelement(2, "p-treeSelect", 1)(3, "input-error-output", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.wrapperClass + " text-start ptreeselectwrapper");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label && ctx.label.length);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.inputClass);
            i0.ɵɵclassProp("disabled", ctx.control == null ? null : ctx.control.disabled)("readonly", ctx.readonly);
            i0.ɵɵproperty("appendTo", ctx.appendTo)("formControl", ctx.control)("id", ctx.id + "_input")("options", ctx.items)("filter", ctx.showFilter)("emptyMessage", ctx.emptyMessage)("placeholder", ctx.placeholder)("selectionMode", ctx.selectionMode);
            i0.ɵɵadvance();
            i0.ɵɵproperty("control", ctx.control);
          }
        },
        dependencies: [i1$1.NgIf, i2$1.NgControlStatus, i2$1.FormControlDirective, InputErrorOutputComponent, i4$1.TreeSelect, i1$1.AsyncPipe],
        styles: [".ptreeselectwrapper p-treeSelect{padding:0}  .ptreeselectwrapper p-treeSelect div.p-treeselect{width:100%;background:transparent;border:none;padding-left:8px;outline:none!important;box-shadow:none!important}  .ptreeselectwrapper p-treeSelect div.p-treeselect .p-tree-selectable{padding-left:.1rem;padding-right:.1rem}"]
      });
    }
  }
  return InputTreeselectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputTreeselectModule = /*#__PURE__*/(() => {
  class InputTreeselectModule {
    static {
      this.ɵfac = function InputTreeselectModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputTreeselectModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InputTreeselectModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, InputSharedModule, TreeSelectModule]
      });
    }
  }
  return InputTreeselectModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputAutocompleteComponent = /*#__PURE__*/(() => {
  class InputAutocompleteComponent extends InputBaseComponent {
    constructor() {
      super();
      this.forceSelection = false;
      this.showEmptyMessage = true;
      this.showOnFocus = true;
      this.completeOnFocus = false;
      this.onSelect = new EventEmitter();
      this.completeMethod = new EventEmitter();
    }
    focusInput() {
      if (this.nativeElement) {
        this.nativeElement.inputEL?.nativeElement.focus();
        this.nativeElement.focused = true;
      }
    }
    showSuggestionList() {
      this.nativeElement?.show(true);
    }
    hideSuggestionList() {
      this.nativeElement?.hide();
    }
    static {
      this.ɵfac = function InputAutocompleteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputAutocompleteComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputAutocompleteComponent,
        selectors: [["input-autocomplete"]],
        viewQuery: function InputAutocompleteComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(AutoComplete, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nativeElement = _t.first);
          }
        },
        inputs: {
          placeholder: "placeholder",
          forceSelection: "forceSelection",
          suggestions: "suggestions",
          field: "field",
          dataKey: "dataKey",
          showEmptyMessage: "showEmptyMessage",
          showOnFocus: "showOnFocus",
          completeOnFocus: "completeOnFocus",
          suffix: "suffix",
          type: "type",
          appendTo: "appendTo"
        },
        outputs: {
          onSelect: "onSelect",
          completeMethod: "completeMethod"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: InputBaseComponent,
          useExisting: forwardRef(() => InputAutocompleteComponent)
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 6,
        vars: 5,
        consts: [["input", ""], ["autoComplete", ""], [3, "for", "innerHTML", 4, "ngIf"], [3, "ngTemplateOutlet", 4, "ngIf"], ["class", "input-group", 4, "ngIf"], [3, "for", "innerHTML"], [3, "ngTemplateOutlet"], [1, "input-group"], [1, "input-group-append"], [1, "input-group-text", 3, "innerHtml"], ["inputStyleClass", "form-control", 3, "completeMethod", "onFocus", "onSelect", "appendTo", "completeOnFocus", "dataKey", "field", "forceSelection", "formControl", "placeholder", "showEmptyMessage", "suggestions", "type"]],
        template: function InputAutocompleteComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, InputAutocompleteComponent_label_1_Template, 2, 4, "label", 2)(2, InputAutocompleteComponent_ng_container_2_Template, 1, 1, "ng-container", 3)(3, InputAutocompleteComponent_div_3_Template, 4, 2, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, InputAutocompleteComponent_ng_template_4_Template, 2, 11, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.wrapperClass + " text-start pAutocompleteWrapper");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label && ctx.label.length);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.suffix);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.suffix);
          }
        },
        dependencies: [i1$1.NgIf, i1$1.NgTemplateOutlet, i2$2.AutoComplete, i2$1.NgControlStatus, i2$1.FormControlDirective, i1$1.AsyncPipe],
        styles: ["input-autocomplete .input-group p-autoComplete{position:relative;flex:1 1 auto;width:1%;min-width:0}  input-autocomplete .input-group input{background:#fff;border-top-right-radius:0;border-bottom-right-radius:0}  input-autocomplete .input-group input:hover:not(:focus){border-color:#a6a6a6!important}  input-autocomplete .input-group .input-group-text{border-top-left-radius:0;border-bottom-left-radius:0}  input-autocomplete .input-group spinnericon{display:none}"]
      });
    }
  }
  return InputAutocompleteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputAutocompleteModule = /*#__PURE__*/(() => {
  class InputAutocompleteModule {
    static {
      this.ɵfac = function InputAutocompleteModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputAutocompleteModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InputAutocompleteModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, AutoCompleteModule, InputSharedModule]
      });
    }
  }
  return InputAutocompleteModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// input directives
let LocalizedDatePipe = /*#__PURE__*/(() => {
  class LocalizedDatePipe {
    constructor(datePipe, translate) {
      this.datePipe = datePipe;
      this.translate = translate;
    }
    transform(value, format) {
      return this.datePipe.transform(value, format, undefined, this.translate.currentLang);
    }
    static {
      this.ɵfac = function LocalizedDatePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LocalizedDatePipe)(i0.ɵɵdirectiveInject(i1$1.DatePipe, 16), i0.ɵɵdirectiveInject(i1$3.TranslateService, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "localizedDate",
        type: LocalizedDatePipe,
        pure: false
      });
    }
  }
  return LocalizedDatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LocalizedDatePipeModule = /*#__PURE__*/(() => {
  class LocalizedDatePipeModule {
    static {
      this.ɵfac = function LocalizedDatePipeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LocalizedDatePipeModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: LocalizedDatePipeModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [LocalizedDatePipe]
      });
    }
  }
  return LocalizedDatePipeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VarDirective = /*#__PURE__*/(() => {
  class VarDirective {
    set ngVar(context) {
      this.context.$implicit = this.context.ngVar = context;
      if (!this.viewRef) {
        this.viewRef = this.vcRef.createEmbeddedView(this.templateRef, this.context);
      }
    }
    constructor(templateRef, vcRef) {
      this.templateRef = templateRef;
      this.vcRef = vcRef;
      this.context = new NgVarContext();
      this.viewRef = null;
    }
    // https://github.com/angular/angular/blob/main/packages/common/src/directives/ng_if.ts
    /**
     * Assert the correct type of the expression bound to the `ngIf` input within the template.
     *
     * The presence of this static field is a signal to the Ivy template type check compiler that
     * when the `NgIf` structural directive renders its template, the type of the expression bound
     * to `ngIf` should be narrowed in some way. For `NgIf`, the binding expression itself is used to
     * narrow its type, which allows the strictNullChecks feature of TypeScript to work with `NgIf`.
     */
    /**
     * Asserts the correct type of the context for the template that `NgIf` will render.
     *
     * The presence of this method is a signal to the Ivy template type-check compiler that the
     * `NgIf` structural directive renders its template with a specific context type.
     */
    // Passing down variable Type
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-shadow
    static ngTemplateContextGuard(dir, ctx) {
      return true;
    }
    static {
      this.ɵfac = function VarDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VarDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: VarDirective,
        selectors: [["", "ngVar", ""]],
        inputs: {
          ngVar: "ngVar"
        },
        standalone: true
      });
    }
  }
  return VarDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class NgVarContext {
  constructor() {
    this.$implicit = null;
    this.ngVar = null;
  }
}
let BaseTabsComponent = /*#__PURE__*/(() => {
  class BaseTabsComponent extends BaseComponent {
    constructor(router, route) {
      super();
      this.router = router;
      this.route = route;
      this.queryParamName = 'tab';
      this.activeTabSub = new BehaviorSubject(0);
      const tab = +this.route.snapshot.queryParams[this.queryParamName];
      this.activeTabSub.next(!isNaN(tab) ? tab : 0);
    }
    ngOnInit() {
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)).pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
        const tab = +this.route.snapshot.queryParams[this.queryParamName];
        this.activeTabSub.next(!isNaN(tab) ? tab : 0);
      });
    }
    setQueryParam(tab) {
      this.activeTabSub.next(tab);
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          [this.queryParamName]: tab ? tab : null
        },
        queryParamsHandling: 'merge' // remove to replace all query params by provided
      });
    }
    static {
      this.ɵfac = function BaseTabsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BaseTabsComponent)(i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BaseTabsComponent,
        selectors: [["ng-component"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 0,
        vars: 0,
        template: function BaseTabsComponent_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return BaseTabsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint angular/document-service: 0 */
function downloadFromUrl(url) {
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.click();
}
function downloadFromB64(b64file, filename, mimeType) {
  const downloadLink = document.createElement('a');
  downloadLink.href = 'data:' + mimeType + ';base64,' + b64file;
  downloadLink.download = filename;
  downloadLink.click();
}
function downloadJSON(jsonObject, filename) {
  const downloadLink = document.createElement('a');
  downloadLink.href = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(jsonObject));
  downloadLink.download = filename;
  downloadLink.click();
}
// TODO
function downloadBlob(blob, filename, mimeType) {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  reader.onloadend = () => {
    let data = reader.result;
    data = data.substr(data.indexOf('base64,') + 7);
    downloadFromB64(data, filename, mimeType);
  };
}

/* eslint angular/document-service: 0 */
function removeSpaces(value) {
  return value.replace(/ /g, '');
}
function fallbackCopyTextToClipboard(text) {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  let successful = false;
  try {
    successful = document.execCommand('copy');
    // const msg = successful ? 'successful' : 'unsuccessful'; // throw error
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }
  document.body.removeChild(textArea);
  if (!successful) {
    throw new Error('copy failed');
  }
}
function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(() => {}, err => {
    fallbackCopyTextToClipboard(text);
    console.error('Async: Could not copy text: ', err);
  });
}
function getTextWidthInPx(text, font) {
  const element = document.createElement('canvas');
  element.style.position = 'absolute';
  element.style.visibility = 'hidden';
  element.style.height = 'auto';
  element.style.width = 'auto';
  element.style.whiteSpace = 'nowrap';
  element.style.font = font;
  element.textContent = text;
  const ctx = element.getContext('2d');
  if (ctx) {
    ctx.font = font;
    const width = Math.round(ctx.measureText(text).width);
    element.remove();
    return width;
  }
  throw new Error('unknown error');
}
function shorten(str, cutAtPixel, font = '12px Arial', shortIndicator = '(...)') {
  if (str.length === 0) {
    return '';
  }
  for (let i = 0; i < str.length; i++) {
    if (getTextWidthInPx(str.substr(0, i), font) > cutAtPixel) {
      return str.slice(0, i - 1) + shortIndicator;
    }
  }
  return str;
}
class PagedRequest {
  constructor() {
    this.Page = 1;
    this.PageSize = 10;
    this.SortBy = 'Id asc';
    this.CultureString = 'de-de';
  }
}
class PagedResponse {
  constructor() {
    this.totalCount = 0;
    this.totalPages = 1;
    this.pagesize = 10;
    this.page = 1;
    this.count = 0;
    this.items = [];
  }
}

// components

/**
 * Generated bundle index. Do not edit.
 */

export { BaseComponent, BaseDirective, BaseLoginComponent, BaseTabsComponent, IFrameComponent, IFrameModule, InputAutocomplete, InputAutocompleteComponent, InputAutocompleteModule, InputBaseComponent, InputCheckboxComponent, InputCheckboxModule, InputDatepickerComponent, InputDatepickerModule, InputDropdownComponent, InputDropdownModule, InputEmailDirective, InputEmailModule, InputFieldMatchingDirective, InputFieldMatchingModule, InputFileComponent, InputFileModule, InputFilterDirective, InputFilterModule, InputMultiselectComponent, InputMultiselectModule, InputNumberDirective, InputNumberModule, InputTextareaComponent, InputTextareaModule, InputTextboxComponent, InputTextboxModule, InputTreeselectComponent, InputTreeselectModule, InputTypeEnum, LightSwitchComponent, LightSwitchModule, LocalizedDatePipe, LocalizedDatePipeModule, NgVarContext, PagedRequest, PagedResponse, SafePipe, SafePipeModule, SecondFactorMethod, SignInResult, VarDirective, copyTextToClipboard, dateBetween, dateInFuture, dateInPast, downloadBlob, downloadFromB64, downloadFromUrl, downloadJSON, getFormGroup, getMaxBrowserWidth, getTextWidthInPx, isMobile, isNullOrEmpty, isObject, isRobot, isSafari, logDirtyControls, logInvalidFormFields, markAsTouchedWithChildren, mergeDeep, observableWithFallbacks, pagedRequestToQueryParams, removeFormControlError, removeSpaces, round, shorten };
